<template>
    <div id="search_component" @drop.prevent="dragFile" @dragover.prevent style="min-height: 100vh">
        <!-- Quote modal -->
        <QuoteModal
            @doClose="close_quote_modal()"
            @doDownload="download_quote_data()"
            @doEdit="close_quote_modal()"
            @doFinish="handleQuoteFinish()"
        />

        <!-- Quote fail modal -->
        <QuoteFailModal @doClose="close_quote_modal()" />

        <!-- Approval modal -->
        <ApprovalModal @doCancel="handleCancelApproval()" @doClose="close_approval_modal()" />

        <!-- No Quote modal -->
        <NoQuoteModal
            :qNoQuoteReason="q_no_quote_reason"
            @update:reason="noQuoteReason = $event"
            @closeModal="close_no_quote_modal"
            @submitReason="no_quote(part_selected, q_no_quote_reason)"
        />

        <!-- Pricing Action modal -->
        <PricingActionModal
            :paDescription="pa_description"
            :qMargin="q_margin"
            :paSuggestedMargin="pa_suggested_margin"
            :qQuote="q_quote"
            :paSuggestedPrice="pa_suggested_price"
            @doUseSuggestedPrice="pricing_action_use_suggested()"
            @doEditPriceManually="close_pricing_action_modal()"
            @doContinueWithYourPrice="show_pricing_action_reason_modal()"
        />

        <!-- Pricing Action Reason modal -->
        <PricingActionModal
            :paReason="paReason"
            @update:paReason="paReason = $event"
            @doClose="close_pricing_action_reason_modal()"
            @doUpdateReason="ajax_pa_update_reason()"
        />

        <!-- Purchase modal -->
        <PurchaseModal
            @doClose="close_purchase_modal()"
            @doEdit="close_purchase_modal()"
            @doDownload="download_purchase_data()"
            @doFinish="handlePurchaseFinish()"
        />

        <!-- Purchase fail modal -->
        <PurchaseFailModal @doClose="close_purchase_modal()" />

        <!-- Duplicate reference modal -->
        <DuplicateReferenceModal
            @doClose="closeReferenceModal()"
            @doSearch="force_duplicate_search()"
            :search_reference="search_reference"
            :duplicate_reference="duplicate_reference"
        />

        <!-- Sales Notes modal -->
        <UserNoteModal @doClose="closeModal(option)" @doSave="save_user_note()" />

        <!-- Admin Notes modal -->
        <AdminNotesModal @doClose="closeModal(option)" @doSave="save_admin_note()" />

        <!-- Modal Price Rule details dialog box -->
        <ModalPriceRuleDetails
            :modalRuleName="modal_rule.name"
            :modalRuleDescription="modal_rule.description"
            :modalRuleInstruction="modal_rule.instructions"
            :suggestedPrice="modal_rule.suggested_price"
            @doClose="close_rule_details()"
            @doUse="use_rule_price(modal_rule.suggested_price)"
        />

        <!-- Modal show part numbers dialog box -->
        <ModalShowParts @doClose="closePartsModal" @doCopy="copyPartsToClipboard" />

        <!-- Modal edit part numbers dialog box -->
        <ModalEditPart
            :partsArray="parts_array"
            @doClose="closeEditPartModal"
            @doEdit="editProvisionalPartsArray"
            @doSearch="editPartsArray"
        />

        <!-- Modal edit customer/reference dialog box -->
        <ModalEditCustomerReference
            @doClose="closeEditCustRefModal"
            @doSubmit="editCustomerReference"
            :modalInputCustomer="modal_input_customer"
            :customerItems="customer_items"
        />

        <!-- Modal show part numbers dialog box -->
        <ModalFuzzyMatches
            :partSelected="this.part_selected"
            :fuzzyPartMatches="fuzzy_part_matches"
            :fuzzySelection="fuzzy_selection"
            :fuzzySelectAll="fuzzy_select_all"
            @doClose="closeFuzzyMatchModal"
            @doReplace="replaceFuzzyMatch"
            @doResarch="researchFuzzyMatch"
        />

        <div id="content" class="container is-fluid">
            <!-- QUOTE Floating action button -->
            <div
                id="quote_button_area"
                style="position: fixed; bottom: 0px; right: 0px; z-index: 998"
                v-if="
                    (is_research_purchase == false) &
                    (is_generic_research == false) &
                    (parts_array.length > 0)
                "
            >
                <button
                    id="quote_button"
                    class="button is-rounded"
                    style="position: absolute; bottom: 1rem; right: 1rem"
                    @click="showQuote"
                >
                    <!-- @dragenter="row_dragenter" @dragleave="row_dragleave" @dragend="row_dragend" @drop="row_drop" -->
                    <span class="icon">
                        <i class="material-icons">add</i>
                    </span>
                    <span>Quote</span>
                </button>
            </div>

            <!-- PURCHASE Floating action button -->
            <div
                id="purchase_button_area"
                style="position: fixed; bottom: 0px; right: 0px; z-index: 998"
                v-if="
                    (is_research_purchase == true) &
                    (is_generic_research == false) &
                    (parts_array.length > 0)
                "
            >
                <button
                    id="purchase_button"
                    class="button is-rounded"
                    style="position: absolute; bottom: 1rem; right: 1rem"
                    @click="showPurchase"
                >
                    <!-- @dragenter="row_dragenter" @dragleave="row_dragleave" @dragend="row_dragend" @drop="row_drop" -->
                    <span class="icon">
                        <i class="material-icons">add</i>
                    </span>
                    <span>Purchase</span>
                </button>
            </div>

            <!-- Previous Quote Values Floating action button -->
            <div
                id="button_previous_values"
                style="position: fixed; top: 56px; right: 0px; z-index: 999"
                v-if="duplicate_part_index >= 0"
            >
                <button
                    id="purchase_button"
                    class="button is-success"
                    style="position: absolute; top: 1rem; right: 1rem"
                    @click="insert_previous_quote_values"
                >
                    <!-- @dragenter="row_dragenter" @dragleave="row_dragleave" @dragend="row_dragend" @drop="row_drop" -->
                    <!-- <span class="icon">
            <i class="material-icons">add</i>
          </span> -->
                    <span>Use Previous Quote</span>
                </button>
            </div>

            <!-- Header -->
            <HeroContainer title="Part Search" />

            <!-- Initial manual user input -->
            <div
                v-if="(parts_array.length == 0) | (duplicate_reference.length > 0)"
                style="display: flex; justify-content: center"
            >
                <div
                    id="initial_inputs"
                    style="display: flex; flex-direction: column; width: 370px; margin-top: 3em"
                >
                    <div class="field" v-if="[1, 2, 4, 20, 24].includes(user_id)">
                        <input
                            id="switch_nsn"
                            type="checkbox"
                            name="switch_nsn"
                            class="switch is-rounded is-info"
                            checked=""
                            v-model="is_nsn"
                        />
                        <label v-if="is_nsn" for="switch_nsn" style="outline: none">NSN/NIIN</label>
                        <label v-else for="switch_nsn" style="outline: none">Part Numbers</label>
                    </div>
                    <div class="field" v-if="hasSearchPartsPermission('gsa')">
                        <input
                            id="switch_gsa"
                            type="checkbox"
                            name="switch_gsa"
                            class="switch is-rounded is-info"
                            checked=""
                            v-model="includeGSA"
                        />
                        <label for="switch_gsa" style="outline: none">Include GSA</label>
                    </div>

                    <div style="display: flex">
                        <textarea
                            id="parts_text"
                            class="textarea"
                            rows="10"
                            placeholder="Part Number(s)"
                            style="display: inline-block; max-width: auto; min-width: auto"
                            v-model="parts_text"
                            @input="parts_text = $event.target.value.toUpperCase()"
                        />
                        <textarea
                            id="qty_text"
                            class="textarea"
                            rows="10"
                            placeholder="QTY(s)"
                            style="
                                display: inline-block;
                                max-width: auto;
                                min-width: auto;
                                width: 6em;
                                white-space: pre;
                            "
                            v-model="quantities_text"
                        />
                    </div>
                    <div style="margin-top: 0.5em">
                        <input
                            class="input"
                            type="text"
                            v-model="search_reference"
                            placeholder="Reference Number"
                            maxlength="40"
                        />
                    </div>

                    <div class="field has-addons" style="margin-top: 0.5em">
                        <div class="control">
                            <div class="select">
                                <select id="search_type" v-model="search_type">
                                    <option disabled hidden value="" style="color: grey">
                                        Type
                                    </option>
                                    <option value="Quote">Quote</option>
                                    <option value="AOG">AOG</option>
                                    <option value="Research">Research</option>
                                    <option disabled hidden value="Batch">Batch</option>
                                </select>
                            </div>
                        </div>
                        <div class="control is-expanded">
                            <div class="select" style="width: 100%">
                                <InputAutosuggest
                                    v-model="search_customer"
                                    :list="customer_items"
                                    placeholder="Customer"
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <button
                            id="search_button"
                            class="button is-info"
                            type="button"
                            @click="start_search"
                            :disabled="searchEnableDisable"
                        >
                            Search
                        </button>
                    </div>
                </div>
            </div>

            <section id="alert_section" style="position: sticky; top: 60px; z-index: 900">
                <!-- Banner Alert section -->
                <div v-for="(banner, idx) in bannerData" :key="'banner_' + idx" style="width: 100%">
                    <div
                        style="text-align: center; margin-bottom: 0.2em"
                        class="notification is-info"
                        v-if="is_banner_displayed(banner)"
                    >
                        {{ banner.text }}
                    </div>
                </div>

                <div style="display: flex; flex-direction: row; justify-content: center">
                    <!-- Textron Alert section -->
                    <div v-for="alert in alertData" :key="'alert_' + alert.part">
                        <div
                            style="margin: 1em 1em 0px 1em"
                            v-if="
                                (alert.part == part_selected) |
                                    (alert.substitute_for == part_selected)
                            "
                        >
                            <div class="notification is-success">
                                Textron Defense Alert:
                                <strong>{{ alert.percent_difference }}</strong>
                            </div>
                        </div>
                    </div>

                    <!-- PricingRule Match section -->
                    <div v-for="(match, idx) in current_pricing_rules" :key="'match_' + idx">
                        <div style="margin: 1em">
                            <div
                                class="notification is-danger"
                                style="padding: 1.25rem 0 1.25rem 1.5rem"
                            >
                                Suggested Price:
                                <strong>{{
                                    numeral(match.suggested_price).format('$0,0,0,0,0.00')
                                }}</strong>
                                <div
                                    @click="show_rule_details(idx)"
                                    style="
                                        display: inline-block;
                                        cursor: pointer;
                                        color: lightgray;
                                        margin-left: 2rem;
                                        margin-right: 0.5rem;
                                    "
                                >
                                    <span
                                        class="icon"
                                        style="
                                            display: inline-block;
                                            cursor: pointer;
                                            color: lightgray;
                                            width: 1em;
                                            height: 1em;
                                        "
                                    >
                                        <i class="material-icons" style="font-size: 1em"
                                            >more_vert</i
                                        >
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Notes section -->
            <section
                v-if="(parts_array.length > 0) & (searchData.length > 0)"
                style="display: flex; flex-wrap: wrap; justify-content: space-around"
            >
                <NotesComponent
                    note_type="sales"
                    style="min-width: 370px; max-width: 500px"
                    v-on:add_user_note="add_user_note"
                    :all_notes="sales_notes"
                    :customer="search_customer"
                    :add_note_auth="true"
                    :part_selected="part_selected"
                    @archive_sales_note="archive_sales_note"
                />
                <NotesComponent
                    note_type="admin"
                    style="min-width: 370px; max-width: 500px"
                    v-on:add_admin_note="add_admin_note"
                    :customer="search_customer"
                    :all_notes="admin_notes"
                    :add_note_auth="admin_auth"
                    :part_selected="part_selected"
                />
            </section>

            <!-- Quote Final -->
            <div
                id="quote_form"
                style="display:none; position:fixed; z-index: 9999; bottom:0px; right:0px; width:250px; padding:1em; background-color:lightgray; border-top-left-radius:1em;
                  transition: width 1s, height 1s; scale 2s;"
            >
                <div class="columns">
                    <div class="field column">
                        <div style="display: flex">
                            <span style="flex-grow: 1">
                                {{ search_type }}: {{ search_customer }}
                            </span>
                            <button
                                class="delete"
                                aria-label="close"
                                v-on:click="hideQuote"
                            ></button>
                        </div>
                    </div>
                </div>
                <form>
                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Part</label>
                            <input
                                id="q_part_number"
                                v-model="part_selected"
                                type="text"
                                class="input is-small"
                                name="part_number"
                                disabled
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">Part Quoted</label>
                            <input
                                id="q_part_quoted"
                                v-model="q_part_quoted"
                                type="text"
                                class="input is-small"
                                name="part_quoted"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Description</label>
                            <input
                                id="q_description"
                                v-on:keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_description"
                                type="text"
                                class="input is-small"
                                name="description"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Vendor</label>
                            <InputAutosuggest
                                @input="edit_quote_vendor"
                                @select="edit_quote_vendor"
                                v-model="q_vendor"
                                id="q_vendor"
                                :list="vendor_items"
                                :isSmall="true"
                                :itemsRightAlign="true"
                                placeholder=""
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Replacement Cost</label>
                            <input
                                id="q_unit_cost"
                                v-on:keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_unit_cost"
                                type="number"
                                class="input is-small"
                                name="cost"
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">List Price</label>
                            <input
                                id="q_list_price"
                                v-model="q_list_price"
                                type="number"
                                class="input is-small"
                                name="list_price"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Quantity</label>
                            <input
                                id="q_quantity"
                                v-on:keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_quantity"
                                type="number"
                                class="input is-small"
                                name="quantity"
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">UOM</label>

                            <div class="field has-addons">
                                <input
                                    id="q_unit_of_measure"
                                    v-on:keyup="edit_quote"
                                    v-on:change="edit_quote"
                                    v-model="q_unit_of_measure"
                                    type="text"
                                    class="input is-small"
                                    name="unit_of_measure"
                                    style="width: 5em"
                                />

                                <span class="select is-small">
                                    <select
                                        id="q_uom_select"
                                        style="width: 0.3em; padding-right: 1.8em"
                                        v-on:change="changeUom"
                                    >
                                        <option value="" disabled selected></option>
                                        <option
                                            v-for="item in uom_items"
                                            :key="'uom_' + item"
                                            :value="item"
                                        >
                                            {{ item }}
                                        </option>
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Margin</label>
                            <div class="field has-addons">
                                <input
                                    id="q_margin"
                                    v-on:keyup="edit_quote"
                                    v-on:change="edit_quote"
                                    v-model="q_margin"
                                    type="number"
                                    min="0"
                                    step="0.1"
                                    class="input is-small"
                                    name="margin"
                                    style="width: 5em"
                                />

                                <span class="select is-small">
                                    <select
                                        id="q_margin_select"
                                        style="width: 0.3em; padding-right: 1.8em"
                                        v-on:change="changeMargin"
                                    >
                                        <option value="" disabled selected></option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </span>
                            </div>
                        </div>

                        <div class="field column">
                            <label class="label is-small">Lead Days</label>
                            <div class="field has-addons">
                                <input
                                    id="q_lead_time"
                                    v-on:keyup="edit_quote"
                                    v-on:change="edit_quote"
                                    v-model="q_lead_time"
                                    type="number"
                                    class="input is-small"
                                    name="lead_time"
                                    style="width: 5em"
                                />

                                <span class="select is-small">
                                    <select
                                        id="q_lead_select"
                                        style="width: 0.3em; padding-right: 1.8em"
                                        v-on:change="changeLead"
                                    >
                                        <option value="" disabled selected></option>
                                        <option
                                            v-for="item in lead_items"
                                            :key="'lead_time_' + item"
                                            :value="item"
                                        >
                                            {{ item }}
                                        </option>
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Exchange</label>
                            <label class="checkbox">
                                <input
                                    id="q_exchange"
                                    :click="edit_quote"
                                    v-on:change="edit_quote"
                                    v-model="q_exchange"
                                    type="checkbox"
                                    name="exchange"
                                />
                            </label>
                        </div>

                        <div class="field column">
                            <label class="label is-small">Core</label>
                            <input
                                id="q_core"
                                :keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_core"
                                type="number"
                                class="input is-small"
                                name="core"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Charge Type</label>
                            <div class="field has-addons">
                                <input
                                    id="q_extra_charge_type"
                                    v-on:keyup="edit_quote"
                                    v-on:change="edit_quote"
                                    v-model="q_extra_charge_type"
                                    type="text"
                                    class="input is-small"
                                    name="extra_charge_type"
                                    style="width: 5em"
                                />

                                <span class="select is-small">
                                    <select
                                        id="q_charge_type_select"
                                        style="width: 0.3em; padding-right: 1.8em"
                                        v-on:change="changeChargeType"
                                    >
                                        <option value="" disabled selected></option>
                                        <option
                                            v-for="item in extra_charge_type_items"
                                            :key="'charge_type_' + item"
                                            :value="item"
                                        >
                                            {{ item }}
                                        </option>
                                    </select>
                                </span>
                            </div>
                        </div>

                        <div class="field column">
                            <label class="label is-small">Charge</label>
                            <input
                                id="q_extra_charge"
                                :keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_extra_charge"
                                type="number"
                                class="input is-small"
                                name="extra_charge"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Quote</label>
                            <input
                                id="q_quote"
                                v-on:keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_quote"
                                type="number"
                                class="input is-small"
                                name="quote"
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">Ext Quote</label>
                            <input
                                id="q_ext_quote"
                                v-model="q_ext_quote"
                                type="number"
                                class="input is-small"
                                name="ext_quote"
                                disabled="True"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Notes</label>
                            <input
                                id="q_notes"
                                v-on:keyup="edit_quote"
                                v-on:change="edit_quote"
                                v-model="q_notes"
                                type="text"
                                class="input is-small"
                                name="notes"
                                placeholder="Notes..."
                            />
                        </div>
                    </div>
                </form>
                <div class="columns" style="margin: 1.75rem 0px 1rem 0px">
                    <div class="column">
                        <button
                            id="quote_submit"
                            class="button is-success"
                            @click="submit_quote(part_selected)"
                            :disabled="is_bpa_noquote"
                        >
                            Submit
                        </button>
                    </div>
                    <div class="column">
                        <button
                            id="quote_none"
                            class="button is-danger"
                            @click="show_no_quote_modal"
                        >
                            No Quote
                        </button>
                    </div>
                </div>
            </div>

            <!-- PURCHASE Form -->
            <div
                id="purchase_form"
                style="display:none; position:fixed; z-index: 9999; bottom:0px; right:0px; width:250px; padding:1em; background-color:lightgray; border-top-left-radius:1em;
                  transition: width 1s, height 1s; scale 2s;"
            >
                <div style="display: flex; flex-direction: row-reverse">
                    <button
                        class="button is-rounded is-small"
                        style="background-color: lightgray"
                        v-on:click="hidePurchase"
                    >
                        <span class="icon">
                            <i class="material-icons">close</i>
                        </span>
                    </button>
                </div>
                <form>
                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Part</label>
                            <input
                                id="p_part_number"
                                v-model="part_selected"
                                type="text"
                                class="input is-small"
                                name="part_number"
                                disabled
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">Description</label>
                            <input
                                id="p_description"
                                v-on:keyup="edit_purchase"
                                v-on:change="edit_purchase"
                                v-model="p_description"
                                type="text"
                                class="input is-small"
                                name="description"
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Cost</label>
                            <input
                                id="p_unit_cost"
                                v-on:keyup="edit_purchase"
                                v-on:change="edit_purchase"
                                v-model="p_unit_cost"
                                type="number"
                                class="input is-small"
                                name="cost"
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">Vendor</label>
                            <InputAutosuggest
                                @input="edit_purchase_vendor"
                                @select="edit_purchase_vendor"
                                v-model="p_vendor"
                                id="p_vendor"
                                :list="vendor_items"
                                :isSmall="true"
                                :itemsRightAlign="true"
                                placeholder=""
                            />
                        </div>
                    </div>

                    <div class="columns">
                        <div class="field column">
                            <label class="label is-small">Quantity</label>
                            <input
                                id="p_quantity"
                                v-on:keyup="edit_purchase"
                                v-on:change="edit_purchase"
                                v-model="p_quantity"
                                type="number"
                                class="input is-small"
                                name="quantity"
                            />
                        </div>

                        <div class="field column">
                            <label class="label is-small">UOM</label>

                            <div class="field has-addons">
                                <input
                                    id="p_unit_of_measure"
                                    v-on:keyup="edit_purchase"
                                    v-on:change="edit_purchase"
                                    v-model="p_unit_of_measure"
                                    type="text"
                                    class="input is-small"
                                    name="unit_of_measure"
                                    style="width: 5em"
                                />

                                <span class="select is-small">
                                    <select
                                        id="p_uom_select"
                                        style="width: 0.3em; padding-right: 1.8em"
                                        v-on:change="change_pUom"
                                    >
                                        <option value="" disabled selected></option>
                                        <option
                                            v-for="item in uom_items"
                                            :key="'p_uom_' + item"
                                            :value="item"
                                        >
                                            {{ item }}
                                        </option>
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label is-small">Purchase Notes</label>
                        <textarea
                            id="p_notes"
                            v-on:keyup="edit_purchase"
                            v-on:change="edit_purchase"
                            v-model="p_notes"
                            type="textarea"
                            class="textarea is-small"
                            rows="5"
                            name="notes"
                            placeholder="Explain the decision to purchase (or not purchase) this part..."
                        >
                        </textarea>
                    </div>
                </form>
                <div class="columns" style="margin: 1em 0px">
                    <div class="column">
                        <button
                            id="purchase_submit"
                            class="button is-success"
                            @click="submit_purchase(part_selected)"
                        >
                            Submit
                        </button>
                    </div>
                    <div class="column">
                        <button
                            id="purchase_none"
                            class="button is-danger"
                            @click="no_purchase(part_selected)"
                        >
                            No Buy
                        </button>
                    </div>
                </div>
            </div>

            <!-- Search results -->
            <div id="search_content" style="white-space: pre-line">
                <!-- <select :value="part_selected" @input="select_changed"> -->

                <!-- <div v-if="searching == false"> -->

                <!-- Part Stats -->
                <div v-if="(parts_array.length > 0) & (duplicate_reference.length == 0)">
                    <div v-for="stat in statsData" :key="stat.id">
                        <keep-alive>
                            <DataTable2 :raw_data="stat" :name="'stat_' + stat" />
                        </keep-alive>
                        <!-- <DataTable  
                :searchData="stat"
              /> -->
                    </div>
                </div>

                <!-- PartsBase Market Plotly figure -->
                <div id="partsbase_market_figure" v-if="partsbaseMarketPlot.length > 0">
                    <PlotPartsBase
                        :plot_data="partsbaseMarketPlot"
                        :pricing="current_partsbase_pricing"
                        :key="marketFigureKey"
                    >
                    </PlotPartsBase>
                </div>

                <!-- CLASSIC SEARCH DATA -->
                <div v-for="(sd, idx) in searchData" :key="idx">
                    <keep-alive>
                        <DataTable2
                            v-if="is_search_data_displayed(sd)"
                            :raw_data="sd"
                            @on-row-dblclick="onRowDblClick"
                            :name="'table_' + sd.site"
                            :customer="search_customer"
                        />
                    </keep-alive>
                </div>

                <!-- PARTS FROM DATABASE TABLES -->
                <DataTablePartDb
                    v-if="dbPartData.length > 0"
                    :name="'table_parts_db'"
                    :site_title="'Parts (Various Sources)'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: is_paged_db_part,
                    }"
                    :rows="dbPartData"
                    :columns="shared_db_part_columns"
                />

                <!-- SUBS FROM DATABASE TABLES -->
                <DataTablePartDb
                    v-if="dbPartDataSub.length > 0"
                    :name="'table_parts_db'"
                    :site_title="'Substitutes (Various Sources)'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: is_paged_db_part,
                    }"
                    :rows="dbPartDataSub"
                    :columns="shared_db_part_columns"
                />

                <!-- CAPABILITIES FROM DATABASE TABLES -->
                <DataTablePartDb
                    v-if="dbCapPartData.length > 0"
                    :name="'table_parts_db'"
                    :site_title="'Capabilities (Various Sources)'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: is_paged_db_part,
                    }"
                    :rows="dbCapPartData"
                    :columns="shared_db_part_columns"
                />

                <!-- CAPABILITIY SUBS FROM DATABASE TABLES -->
                <DataTablePartDb
                    v-if="dbCapPartDataSub.length > 0"
                    :name="'table_parts_db'"
                    :site_title="'Capabilities Subs (Various Sources)'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: is_paged_db_part,
                    }"
                    :rows="dbCapPartDataSub"
                    :columns="shared_db_part_columns"
                />

                <!-- ASYNC TABLES (ALL)-->

                <DataTableAsync
                    v-if="async_result.test_sa_flow.length > 0"
                    :name="'table_test_sa_flow'"
                    :site_title="'Test SA Flow'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: true,
                    }"
                    :rows="async_result.test_sa_flow"
                    :columns="columns.columns_test"
                />

                <!-- ASYNC SELENIUM-->
                <DataTableAsync
                    v-if="async_selenium_filtered.length > 0"
                    :name="'selenium_table'"
                    :site_title="'Selenium Sites'"
                    @on-row-dblclick="onRowPartDbDblClick"
                    :select-options="{
                        enabled: true,
                        selectOnCheckboxOnly: true,
                        selectionText: 'parts selected',
                    }"
                    :pagination-options="{
                        enabled: true,
                    }"
                    :rows="async_selenium_filtered"
                    :columns="columns.columns_selenium"
                />

                <!-- GOOGLE SEARCH -->
                <div v-if="google_search.length > 0">
                    <div class="title_div">
                        <span class="site">Google Search</span>
                    </div>
                    <vue-good-table
                        ref="table_google_search"
                        :key="google_search_key"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [5, 10, 20, 30, 40, 50],
                            perPage: 5,
                        }"
                        :columns="[
                            {
                                label: 'Title',
                                field: 'title',
                                type: 'text',
                            },
                            {
                                label: 'Price',
                                field: 'price',
                                type: 'number',
                                formatFn: function (value) {
                                    return numeral(value).format('$0,0,0,0,0.00')
                                },
                            },
                            {
                                label: 'Link',
                                field: 'link',
                                html: true,
                            },
                            {
                                label: 'Image',
                                field: 'image',
                                html: true,
                            },
                        ]"
                        :rows="google_search"
                    >
                    </vue-good-table>
                </div>

                <!-- LEAD TIME STATS -->
                <div v-if="lead_time_stats.rows.length > 0">
                    <div class="title_div">
                        <span class="site">Lead Time Stats</span>
                        <!-- <a class="site_link" :href="raw_data.url">view page</a> -->
                    </div>
                    <vue-good-table
                        ref="table_lead_time_stats"
                        :columns="[
                            {
                                label: 'Part',
                                field: 'part_number',
                                type: 'text',
                            },
                            {
                                label: 'Vendor',
                                field: 'vendor',
                                type: 'text',
                            },
                            {
                                label: 'Avg Lead (days)',
                                field: 'mean',
                                type: 'number',
                            },
                            {
                                label: 'Last Lead (days)',
                                field: 'last',
                                type: 'number',
                            },
                        ]"
                        :rows="lead_time_stats.rows"
                    >
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next'
    import DataTable2 from '@/components/shared/DataTable2.vue'
    import DataTablePartDb from '@/components/shared/DataTablePartDb.vue'
    import DataTableAsync from '@/components/shared/DataTableAsync.vue'
    import NotesComponent from '@/components/shared/NotesComponent.vue'
    import PlotPartsBase from '@/components/shared/PlotPartsBase.vue'
    import InputAutosuggest from '@/components/shared/InputAutosuggest.vue'
    import DataFrame from 'dataframe-js'
    import '@/assets/bulma.min.css'
    import '@/assets/styles.css'
    import moment from 'moment'
    import numeral from 'numeral'
    import HeroContainer from '@/components/shared/HeroContainer.vue'
    import { useDropdownsStore } from '@/stores/dropdownsStore'
    import { mapStores } from 'pinia'
    import { useUserStore } from '@/stores/userStore'
    import {
        PREFECT_SEARCH_POLL,
        SEARCH_PARTSDB,
        USER_NOTE_ARCHIVE,
        SEARCHACTION_FINISH,
        QUOTE_CREATE,
        QUOTE_UPDATE_REASON,
        PURCHASE_RESEARCH_CREATE,
        USER_NOTE_CREATE,
        ADMIN_NOTE_CREATE,
        QUOTE_EDIT_PART,
        STREAM_QUOTE,
        STREAM_RESEARCH,
        STREAM_PART,
    } from '@/data/url'

    // Modals
    import QuoteModal from '@/components/modals/QuoteModal.vue'
    import QuoteFailModal from '@/components/modals/QuoteFailModal.vue'
    import ApprovalModal from '@/components/modals/ApprovalModal.vue'
    import NoQuoteModal from '@/components/modals/NoQuoteModal.vue'
    import PricingActionModal from '@/components/modals/PricingActionModal.vue'
    import PurchaseModal from '@/components/modals/PurchaseModal.vue'
    import PurchaseFailModal from '@/components/modals/PurchaseFailModal.vue'
    import DuplicateReferenceModal from '@/components/modals/DuplicateReferenceModal.vue'
    import UserNoteModal from '@/components/modals/UserNoteModal.vue'
    import AdminNotesModal from '@/components/modals/AdminNotesModal.vue'
    import ModalPriceRuleDetails from '@/components/modals/ModalPriceRuleDetails.vue'
    import ModalEditCustomerReference from '@/components/modals/ModalEditCustomerReference.vue'
    import ModalFuzzyMatches from '@/components/modals/ModalFuzzyMatches.vue'

    // TABLE columnS
    import { columns_test } from '@/table_columns/test.js'
    import { columns_selenium } from '@/table_columns/selenium.js'

    // import mitt from 'mitt';

    // FOR DEBUGGING -----------------------------------------------
    window.DataFrame = DataFrame // <------------------------------

    // const emitter = mitt();

    export default {
        name: 'SearchComponent',
        components: {
            VueGoodTable,
            DataTable2,
            DataTablePartDb,
            DataTableAsync,
            NotesComponent,
            PlotPartsBase,
            InputAutosuggest,
            HeroContainer,
            QuoteModal,
            QuoteFailModal,
            ApprovalModal,
            NoQuoteModal,
            PricingActionModal,
            PurchaseModal,
            PurchaseFailModal,
            DuplicateReferenceModal,
            UserNoteModal,
            AdminNotesModal,
            ModalPriceRuleDetails,
            ModalEditCustomerReference,
            ModalFuzzyMatches,
        },
        props: [
            'route_search_action_object',
            'route_redo_search_object',
            'route_research_parts_list',
            'route_generic_research_part_list',
            'route_sa_id',
        ],
        data: function () {
            return {
                new_search: false,
                columns: {
                    columns_test: columns_test,
                    columns_selenium: columns_selenium,
                },
                async_result: {
                    test_sa_flow: [],
                    selenium: [],
                },
                fuzzy_selection: [],
                fuzzy_select_all: false,
                is_nsn: false,
                research_purchases_only: false,
                generic_research_only: false,
                duplicate_part_index: -1,
                duplicate_reference: [], // Array of objects [{"name": "Richard Alexander", "time": "1 day ago", parts: []},
                // alert_observer: null, // Make alerts sticky and style background
                marketFigureKey: 0, // Re-render figure by changing key
                numeral: numeral,
                user_first: 'Login',
                search_action_id: 0,
                // searching: false,
                search_type: '',
                search_customer: '',
                search_reference: '',
                modal_input_customer: '',
                alertData: [],
                bannerData: [], // Array of objects [{customer: , part_number: , text: , }]
                searchDataRaw: [],
                dbPartDataRaw: [],
                dbCapPartDataRaw: [],
                research_subs_dict: {},
                // searchData: [],
                statsData: [],
                parts_text: '',
                quantities_text: '',
                provisional_parts_array: [],
                // parts_array: [],
                // part_selected:'',
                // part_index: 0,
                sales_lastyr: 0,
                sales_currentyr: 0,
                sales_tot_qty: 0,
                quotes_lastyr: 0,
                quotes_currentyr: 0,
                quotes_tot_qty: 0,
                total_sales: 0,
                total_quotes: 0,
                avg_cost: 0,
                avg_price: 0,
                avg_quote: 0,
                win_percent: 0,
                avg_margin: 0,
                last_quote: 0,
                stream_data: '',
                response_buffer: '', // We can't controll how the stream API buffers the response, so we'll wait for a closing ]
                upload_files: [],
                // quote properties
                q_part_number: '',
                q_part_quoted: '',
                q_description: '',
                q_quantity: '',
                q_vendor: '',
                q_unit_cost: '',
                q_list_price: '',
                q_margin: '',
                q_quote: '',
                q_ext_quote: '',
                q_notes: '',
                q_lead_time: '',
                q_unit_of_measure: '',
                q_exchange: false,
                q_core: '',
                q_extra_charge_type: '',
                q_extra_charge: '',
                q_no_quote_reason: '',
                // purchase properties
                p_part_number: '',
                p_description: '',
                p_quantity: '',
                p_vendor: '',
                p_unit_cost: '',
                p_notes: '',
                p_unit_of_measure: '',
                //
                sales_notes: [], // [{text:"This is my note text", user:"Rla", timestamp:"2020-02-03 16:02:02.523039+00"}, {text:"More notes", user:"Shh", timestamp:"2020-02-03 15:02:02.443241+00"}],
                admin_notes: [], // [{text:"Admin note", user:"TAO", timestamp:"2020-01-31 23:02:02.740221+00"}, {text:"Another admin note", user:"Tsk", timestamp:"2020-01-31 23:02:02.740221+00"}],
                pricing_rule_match: [],
                modal_rule: {},
                partsbase_pricing: [],
                partsbase_market: [],
                all_fuzzy_part_matches: {},
                all_google_search: {},
                google_search_key: 0,
                quoteData: [], // The array indicies match those of the parts_array and elements are dicts of quote objects.  OLD:Each array element is dict of {part: 12-345, data: {datadict}}
                purchaseData: [], // The array indicies match those of the parts_array and elements are dicts of purchase objects.
                // Pricing action data for modal
                pa_suggested_price: 0,
                pa_suggested_margin: 0,
                pa_description: '',
                pa_reason: '',
                pa_id: 0,
                bpa_parts: [],
                includeGSA: false,
            }
        },
        mounted: function () {
            this.resetVars()
            // Get props passed by route params
            if (this.route_search_action_object) {
                // Passed from MyQuotes to view/resume a quote
                let sa = this.route_search_action_object
                this.search_action_id = sa.id
                this.set_search_props(sa)
                // Query database for stored quote data
                this.ajax_stream_quote_from_db(sa.id)
            } else if (this.route_sa_id) {
                // Passed from the URL
                this.search_action_id = this.route_sa_id
                // Query database for stored quote data
                this.ajax_stream_quote_from_db(this.route_sa_id)
            }
            if (this.route_redo_search_object) {
                let sa = this.route_redo_search_object
                // Pass the search action id to start a new search with same parameters
                this.search_action_id = sa.id
                this.is_nsn = sa.is_nsn // This has no value since coming from MyQuotes
                this.set_search_props(sa)
                // Start a new search
                let force_search = false
                this.search_stream(
                    this.parts_array,
                    [],
                    this.search_action_id,
                    this.search_type,
                    this.search_customer,
                    this.search_reference,
                    this.is_nsn,
                    this.includeGSA,
                    force_search
                )
            }
            if (this.route_research_parts_list) {
                this.research_purchases_only = true
                // Never display the quote button
                // don't create quotes for parts
                // parts should have purchaseData, not quoteData
                // doubleclick opens purchase_form, not quote_form
                let parts_list = this.route_research_parts_list
                this.parts_array = parts_list
                this.searchStore.set_part_selected(parts_list[0])
                this.searchStore.set_part_index(0)

                this.init_purchase_data(parts_list)
                this.ajax_research_parts(parts_list)
            }
            if (this.route_generic_research_part_list) {
                let parts_list = this.route_generic_research_part_list
                if (typeof parts_list == 'string') {
                    parts_list = JSON.parse(parts_list)
                }
                this.generic_research_only = true
                // Never display the quote button
                // Never display the purchase button
                this.parts_array = parts_list
                this.searchStore.set_part_selected(parts_list[0])
                this.searchStore.set_part_index(0)

                this.ajax_research_parts(parts_list)
            }

            // Set sticky alert section events with IntersectionObserver
            // When alert_section is scrolled up, it will stick and have a light background
            const intersect_options = {
                root: document.getElementById('app'),
                rootMargin: '0px 0px -100% 0px',
                threshold: 0,
            }
            this.alert_observer = new IntersectionObserver(io_callback, intersect_options)
            this.alert_observer.observe(document.getElementById('alert_section'))
            // eslint-disable-next-line no-unused-vars
            function io_callback(entries, observer) {
                entries.forEach((entry) => {
                    entry.target.classList.toggle('active', entry.isIntersecting)
                    if (entry.isIntersecting) {
                        alert('intersect!')
                    }
                })
            }
        },
        watch: {
            search_action_id: function (new_id, old_id) {
                let view_all = false
                if (!this.new_search) {
                    // We must poll for historical data, not new search data
                    view_all = true
                }
                if (new_id == old_id) {
                    return
                } else if (new_id > 0) {
                    this.ajax_prefect_search_poll(new_id, view_all)
                }
            },
            duplicate_reference: function () {
                if (this.duplicate_reference.length > 0) {
                    document.getElementById('duplicate_reference_modal').classList.add('is-active')
                } else {
                    document
                        .getElementById('duplicate_reference_modal')
                        .classList.remove('is-active')
                }
            },
            part_index: function () {
                this.partChange()
                window.scrollTo(0, 0)
            },
            searchData: function () {
                // When new search data arrives, recalculate summary stats
                this.calcStats()
            },
            partsbaseMarketPlot: function () {
                // Change key to force the component to re-render
                // otherwise it will have height=0
                this.marketFigureKey += 1
            },
            fuzzy_select_all() {
                this.fuzzy_selection = []
                if (this.fuzzy_select_all) {
                    this.fuzzy_part_matches.forEach((match) =>
                        this.fuzzy_selection.push(match.part_alternate)
                    )
                }
            },
        },
        computed: {
            ...mapStores(useUserStore),
            // ASYNC SEARCH RESULTS
            // SELENIUM GROUP TABLE
            async_selenium_filtered() {
                let selenium = []
                let raw_data = [...this.async_result.selenium] // Copy to new array
                let part_selected = this.part_selected
                for (let raw_idx in raw_data) {
                    let raw_row = raw_data[raw_idx]
                    let part_number = raw_row.input_part_number
                    if (part_number == part_selected) {
                        selenium.push(raw_row)
                    }
                }
                return selenium
            },
            // DB Part results
            shared_db_part_columns() {
                let numeral = this.numeral
                return [
                    {
                        label: 'Updated',
                        field: 'time_updated',
                        type: 'text',
                        formatFn: (date) => {
                            if (date) {
                                if (date.includes('T')) {
                                    return date.split('T')[0]
                                }
                            }
                            return date
                        },
                    },
                    {
                        label: 'Source',
                        field: 'source',
                        type: 'text',
                    },
                    {
                        label: 'Part Number',
                        field: 'part_number',
                        type: 'text',
                    },
                    {
                        label: 'Mfr Number',
                        field: 'part_number_manufacturer',
                        type: 'text',
                    },
                    {
                        label: 'Description',
                        field: 'description',
                        type: 'text',
                    },
                    {
                        label: 'Price',
                        field: 'price',
                        type: 'number',
                        formatFn: (value) => {
                            if (value) {
                                return numeral(value).format('$0,0,0,0,0.00')
                            }
                            return value
                        },
                    },
                    {
                        label: 'UOM',
                        field: 'uom',
                        type: 'text',
                    },
                    {
                        label: 'Qty',
                        field: 'qty_in_stock',
                        type: 'number',
                    },
                    {
                        label: 'In Stock',
                        field: 'is_in_stock',
                        type: 'boolean',
                    },
                    {
                        label: 'Bulk',
                        field: 'price_per_qty',
                        type: 'text',
                        tdClass: 'preformatted',
                        formatFn: (list_of_obj) => {
                            let text_list = ''
                            for (let obj of list_of_obj) {
                                if (text_list != '') {
                                    text_list += '\n'
                                }
                                let qty_len = obj.qty.toString().length
                                let spaces = ''
                                if (qty_len < 3) {
                                    spaces = '\u00A0'.repeat(3 - qty_len)
                                }
                                let this_price = `${obj.qty}:\u00A0${spaces}${numeral(obj.unit_price).format('$0,0,0,0,0.00')}`
                                text_list += this_price
                            }
                            return text_list
                        },
                    },
                    {
                        label: 'Qty Min',
                        field: 'qty_minimum',
                        type: 'number',
                    },
                    {
                        label: 'Qty Multi',
                        field: 'qty_multiples',
                        type: 'number',
                    },
                    {
                        label: 'Lead Days',
                        field: 'lead_time_days',
                        type: 'text',
                    },
                    {
                        label: 'Cond',
                        field: 'condition',
                        type: 'text',
                    },
                ]
            },
            is_paged_db_part: function () {
                if (this.dbPartData.length <= 10) {
                    return false
                } else {
                    return true
                }
            },
            is_paged_db_sub: function () {
                if (this.dbPartDataSub.length <= 10) {
                    return false
                } else {
                    return true
                }
            },
            dbPartData() {
                let part_data = []
                let raw_data = [...this.dbPartDataRaw]
                let part_selected = this.part_selected
                for (let raw_idx in raw_data) {
                    let raw_row = raw_data[raw_idx]
                    let part_number = raw_row.part_number
                    if (part_number == part_selected) {
                        part_data.push(raw_row)
                    }
                }
                return part_data
            },
            dbPartDataSub() {
                let sub_data = []
                let raw_data = [...this.dbPartDataRaw]
                let part_selected = this.part_selected
                for (let raw_idx in raw_data) {
                    let raw_row = raw_data[raw_idx]
                    let sub_for = raw_row.substitute_for
                    if (sub_for) {
                        if (sub_for.includes(part_selected)) {
                            sub_data.push(raw_row)
                        }
                    }
                }
                return sub_data
            },
            dbCapPartData() {
                let part_data = []
                let raw_data = [...this.dbCapPartDataRaw]
                let part_selected = this.part_selected
                for (let raw_idx in raw_data) {
                    let raw_row = raw_data[raw_idx]
                    let part_number = raw_row.part_number
                    if (part_number == part_selected) {
                        part_data.push(raw_row)
                    }
                }
                return part_data
            },
            dbCapPartDataSub() {
                let sub_data = []
                let raw_data = [...this.dbCapPartDataRaw]
                let part_selected = this.part_selected
                for (let raw_idx in raw_data) {
                    let raw_row = raw_data[raw_idx]
                    let sub_for = raw_row.substitute_for
                    if (sub_for) {
                        if (sub_for.includes(part_selected)) {
                            sub_data.push(raw_row)
                        }
                    }
                }
                return sub_data
            },
            // Pulse items
            pn_count: {
                get() {
                    return this.searchStore.pulse_pn_count
                },
                set(value) {
                    this.searchStore.set_pulse_pn_count(value)
                },
            },
            pn_total: {
                get() {
                    return this.searchStore.pulse_pn_total
                },
                set(value) {
                    this.searchStore.set_pulse_pn_total(value)
                },
            },
            process: {
                get() {
                    return this.searchStore.pulse_process
                },
                set(value) {
                    this.searchStore.set_pulse_process(value)
                },
            },
            sub_count: {
                get() {
                    return this.searchStore.pulse_sub_count
                },
                set(value) {
                    this.searchStore.set_pulse_sub_count(value)
                },
            },
            sub_total: {
                get() {
                    return this.searchStore.pulse_sub_total
                },
                set(value) {
                    this.searchStore.set_pulse_sub_total(value)
                },
            },
            fuzzy_part_matches() {
                function get_diff_html(alternate, instructions) {
                    let html = ''
                    let a = 0 // index of alternate string
                    for (let i of instructions) {
                        if (i == 'same') {
                            html += alternate[a]
                            a += 1
                        } else if (i == 'del') {
                            // Do not increment a for deletions
                            html += `<span class='levenshtein_delete'></span>`
                        } else if (i == 'insert') {
                            html += `<span class='levenshtein_insert'>${alternate[a]}</span>`
                            a += 1
                        } else if (i == 'sub') {
                            html += `<span class='levenshtein_sub'>${alternate[a]}</span>`
                            a += 1
                        }
                    }
                    return html
                }
                let pm = this.all_fuzzy_part_matches
                if (Object.prototype.hasOwnProperty.call(pm, this.part_selected)) {
                    let matches = [...this.all_fuzzy_part_matches[this.part_selected]]
                    for (let m in matches) {
                        let match = matches[m]
                        // Find string differences and create HTML spans
                        matches[m]['html'] = get_diff_html(match.part_alternate, match.edits)
                    }
                    return matches
                }
                return []
            },
            num_fuzzy_matches() {
                return this.fuzzy_part_matches.len
            },
            google_search() {
                let all_gs = this.all_google_search
                let key = this.google_search_key
                if (Object.prototype.hasOwnProperty.call(all_gs, this.part_selected) & (key > 0)) {
                    let part = this.part_selected
                    let gs = all_gs[part]
                    return gs
                }
                return []
            },
            lead_time_stats() {
                let this_part = this.part_selected
                var lead_stats = []
                let data = []
                let cols = []
                for (const sdr of this.searchDataRaw) {
                    if ((sdr.site == 'Quotes') & (sdr.part == this_part)) {
                        data.push(...sdr.data)
                        break
                    }
                }
                let df = new DataFrame(data)
                cols = df.listColumns()
                if (cols.includes('lead_time')) {
                    df = df
                        .filter((row) => row.get('lead_time') > 0)
                        .filter((row) => row.get('vendor').includes('Textron'))
                    let groups = df.groupBy('part_number', 'vendor')
                    let df_agg = groups.aggregate((group) => {
                        let mean = group.stat.mean('lead_time')
                        let last = group.getRow(0).get('lead_time') // First row is most recent
                        return [mean, last]
                    })
                    df_agg = df_agg.chain(
                        //row  =>   //row.set('margin', row.get('profit')/row.get('price'))
                        (row) => row.set('mean', row.get('aggregation')[0]),
                        (row) => row.set('last', row.get('aggregation')[1])
                    )
                    lead_stats = df_agg.toCollection()
                }

                return { columns: cols, rows: lead_stats }
            },
            is_research_purchase() {
                return this.research_purchases_only
            },
            is_generic_research() {
                return this.generic_research_only
            },
            is_staff: function () {
                return this.userStore.is_staff
            },
            user_id() {
                return this.userStore.id
            },

            is_bpa_noquote() {
                if (this.bpa_parts.includes(this.part_selected)) {
                    return true
                }
                if (this.bpa_parts.includes(this.q_part_quoted)) {
                    return true
                }
                return false
            },
            dashboard_permissions: function () {
                let dashboard_permissions = this.userStore.dashboard_permissions
                if (dashboard_permissions) {
                    return dashboard_permissions
                }
                return []
            },
            part_selected: function () {
                return this.searchStore.part_selected
            },
            admin_auth() {
                // Get admin auth from logged in user
                return this.userStore.is_staff
            },
            current_pricing_rules() {
                let current_pricing_rules = []
                for (let match of this.pricing_rule_match) {
                    if (match.part_number == this.part_selected) {
                        current_pricing_rules.push(match)
                    }
                }
                return current_pricing_rules
            },
            current_partsbase_pricing() {
                for (let pricing of this.partsbase_pricing) {
                    if (pricing.part == this.part_selected) {
                        return pricing.data
                    }
                }
                return {}
            },
            dropdownsStore() {
                return useDropdownsStore()
            },
            lead_items() {
                return this.dropdownsStore.lead_days
            },
            extra_charge_type_items() {
                return this.dropdownsStore.extra_charge_type
            },
            vendor_items() {
                return this.dropdownsStore.vendor
            },
            uom_items() {
                return this.dropdownsStore.uom
            },
            customer_items() {
                return this.dropdownsStore.customer
            },
            searchEnableDisable() {
                if (this.userStore.id) {
                    if (this.userStore.id == 1) {
                        // Chris can search without specifying a reference number
                        return !(
                            (this.parts_text.length >= 3) &
                            (this.search_type != '') &
                            (this.search_customer != '')
                        )
                    }
                }
                return !(
                    (this.parts_text.length >= 3) &
                    (this.search_type != '') &
                    (this.search_customer != '') &
                    (this.search_reference.length >= 3)
                )
            },
            partsbaseMarketPlot() {
                // let market_data = []
                let part = this.part_selected
                for (let pbm of this.partsbase_market) {
                    if (pbm.part == part) {
                        // Format data for plotly
                        let data = [
                            {
                                type: 'scatter',
                                name: 'Demand',
                                x: [],
                                y: [],
                                line: { shape: 'spline' },
                            },
                            {
                                type: 'scatter',
                                yaxis: 'y2',
                                name: 'Supply',
                                x: [],
                                y: [],
                                line: { shape: 'spline' },
                            },
                        ]
                        for (let pbm_data of pbm.data) {
                            if ((pbm_data.source == 'demand') & (pbm_data.type == 'Total')) {
                                data[0].x.push(pbm_data.date)
                                data[0].y.push(pbm_data.value)
                            }
                            if ((pbm_data.source == 'supply') & (pbm_data.type == 'NE')) {
                                data[1].x.push(pbm_data.date)
                                data[1].y.push(pbm_data.value)
                            }
                        }
                        return data
                    }
                }
                return []
            },
            searchData: function () {
                // Clean the raw search data and return data
                // containing a single datateble for every
                // site-part pair
                let raw_data = [...this.searchDataRaw] // Copy to new array
                let cleaned_search_data = []
                let quote_sale = ['Quotes', 'Sales', 'Repair Orders']
                let inventory = [
                    'Greenwood Ponca Inventory',
                    'GlobalParts Inventory',
                    'Inventory ComponentControl',
                    'Inventory GlobalParts',
                ]
                // let research_subs_dict = this.research_subs_dict
                var research_subs_dict = {}
                // Loop through raw data
                for (let raw_idx in raw_data) {
                    let raw_site = raw_data[raw_idx].site
                    let raw_part = raw_data[raw_idx].part
                    let raw_sub = raw_data[raw_idx].substitute_for
                    // Part research could be on substitutes, so keep track of the reverse relations
                    if (raw_sub) {
                        if (!Object.prototype.hasOwnProperty.call(research_subs_dict, raw_sub)) {
                            research_subs_dict[raw_sub] = []
                        }
                        if (!research_subs_dict[raw_sub].includes(raw_part)) {
                            research_subs_dict[raw_sub].push(raw_part)
                        }
                    }
                    let idx_match = -1
                    let idx_overwrite = -1
                    // Compare raw data to cleaned data to see if raw should be appended to clean
                    for (let clean_idx in cleaned_search_data) {
                        let clean_site = cleaned_search_data[clean_idx].site
                        let clean_part = cleaned_search_data[clean_idx].part

                        // Handle inventory data
                        if (
                            (clean_site == raw_site) &
                            inventory.includes(clean_site) &
                            (clean_part == raw_part)
                        ) {
                            idx_overwrite = clean_idx
                            break
                        }
                        // Handle quote/sales data
                        if (quote_sale.includes(clean_site)) {
                            if ((clean_site == raw_site) & (clean_part == raw_part)) {
                                // idx_overwrite = clean_idx
                                idx_match = clean_idx
                                break
                            }
                        }
                        // Handle search data
                        if (
                            (clean_site == raw_site) &
                            ((clean_part == raw_sub) | (clean_part == raw_part))
                        ) {
                            idx_match = clean_idx
                            break
                        }
                    }
                    if (idx_overwrite > -1) {
                        let overwrite_data = JSON.parse(JSON.stringify(raw_data[raw_idx]))
                        cleaned_search_data[idx_overwrite] = overwrite_data
                    } else if (idx_match < 0) {
                        // Create a new datatable (deep clone the original object)
                        let copy_data = JSON.parse(JSON.stringify(raw_data[raw_idx])) //Object.assign({}, raw_data[raw_idx]) // {...raw_data[raw_idx]}  // Copy to new object
                        cleaned_search_data.push(copy_data)
                    } else {
                        // Append to the existing data
                        let append_data = [...raw_data[raw_idx].data] // Copy to new array
                        cleaned_search_data[idx_match].data.push(...append_data) // Append each element to cleaned data
                        // Remove any Data=None rows
                    }
                }
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.research_subs_dict = research_subs_dict
                return cleaned_search_data
            },
            current_year: function () {
                return moment().format('YYYY')
            },
            last_year: function () {
                return moment().subtract(1, 'year').format('YYYY')
            },
            parts_array: {
                get: function () {
                    return this.searchStore.parts_array
                },
                set: function (new_array) {
                    this.searchStore.set_parts_array(new_array)
                },
            },
            quantity_array: function () {
                // Split part numbers text into array
                let quantity_array = this.quantities_text.split(/[ \n\t]/) // All whitespace
                for (let i = quantity_array.length - 1; i >= 0; i--) {
                    // Remove blanks
                    if (quantity_array[i] == '') {
                        quantity_array.splice(i, 1)
                    }
                }
                return quantity_array
            },
            part_index: function () {
                return this.searchStore.part_index
            },
            searching: {
                get: function () {
                    return this.searchStore.ajax_searching
                },
                set: function (is_searching) {
                    this.searchStore.set_ajax_searching(is_searching)
                },
            },
        },
        methods: {
            hasSearchPartsPermission(option) {
                let permissions = this.searchStore.search_parts_permissions
                let response = false
                if (permissions.length < 1) {
                    return response
                }
                return permissions.some((permission) => permission.vendor === option)
            },
            async_result_router(result_list) {
                // Data will be an object of form
                // {group: 'str', batch: 'str', type: 'str', data: {search_data}, ...}
                // Use the GROUP to route the data to the correct table
                // BATCH will be 'complete' or 'part' and will determine how the data is updated

                for (let result of result_list) {
                    if (result.data != null) {
                        let payload = result.data
                        let group = payload.group
                        this.async_result[group].push(...payload.data)
                    }
                }
            },
            ajax_prefect_search_poll(search_action_id, view_all = false, from_timeout = false) {
                // return
                // eslint-disable-next-line no-unreachable
                this.process = 'Async search poll'
                let url = PREFECT_SEARCH_POLL
                if (!from_timeout) {
                    // Only set to true on the first call
                    // Otherwise the spinner will keep spinning
                    this.searching = true
                }
                let this_vue = this
                let async_result_router = this.async_result_router
                let ajax_prefect_search_poll = this.ajax_prefect_search_poll
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({
                        search_action_id: search_action_id,
                        view_all: view_all,
                    }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            async_result_router(res.result_list)
                            if (res.search_complete == true) {
                                this_vue.searching = false
                            } else {
                                setTimeout(
                                    ajax_prefect_search_poll,
                                    5000,
                                    search_action_id,
                                    view_all,
                                    true
                                )
                            }
                        }
                    })
                    .catch((e) => {
                        this_vue.searching = false
                        console.error(JSON.stringify(e.message))
                    })
            },
            ajax_get_db_parts() {
                this.process = 'All DB Parts'
                this.dbPartDataRaw = [] // Reset query data
                this.dbCapPartDataRaw = []
                let url = SEARCH_PARTSDB
                this.searching = true
                let this_vue = this
                function set_dash(this_vue, data) {
                    this_vue.dbPartDataRaw = data
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ part_list: this.parts_text }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        this_vue.searching = false
                        if (res.success) {
                            set_dash(this_vue, res.data)
                        }
                    })
                    .catch((e) => {
                        this_vue.searching = false
                        console.error(JSON.stringify(e.message))
                    })
            },
            get_attr_title(attributes) {
                let attr_text = ''
                for (const key in attributes) {
                    attr_text += `${key}: ${attributes[key]}\n`
                }
                return attr_text
            },
            closeFuzzyMatchModal() {
                this.provisional_parts_array = [...this.parts_array] // Copy of array
                let modal = document.getElementById('modal_fuzzy_matches')
                this.fuzzy_selection = []
                this.fuzzy_select_all = false
                modal.classList.remove('is-active')
            },
            showFuzzyMatchModal() {
                this.provisional_parts_array = [...this.parts_array] // Copy of array
                let modal = document.getElementById('modal_fuzzy_matches')
                this.fuzzy_selection = []
                this.fuzzy_select_all = false
                modal.classList.add('is-active')
            },
            researchFuzzyMatch() {
                window.open(`/#/Research?parts=${JSON.stringify(this.fuzzy_selection)}`)
            },
            replaceFuzzyMatch() {
                let p_idx = this.part_index
                let val = this.fuzzy_selection[0]
                this.provisional_parts_array[p_idx] = val.toUpperCase().replace(/[ \t\n]+/, ' ') // Upper case and single spaces
                this.editPartsArray()
            },
            is_banner_displayed(banner) {
                // Given banner data, decide whether to display in the search results
                if (banner.part_number == this.part_selected) {
                    return true
                }
                if (banner.part_quoted == this.part_selected) {
                    return true
                }
                if (banner.customer_name == this.search_customer) {
                    return true
                }
                if (this.is_research_purchase | this.is_generic_research) {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            this.research_subs_dict,
                            banner.part_number
                        )
                    ) {
                        if (
                            this.research_subs_dict[banner.part_number].includes(this.part_selected)
                        ) {
                            return true
                        }
                    }
                }
                return false
            },
            is_search_data_displayed(sd) {
                // Given search data sd, decide whether to display in the search results
                if (sd.part == this.part_selected) {
                    return true
                }
                if (this.is_research_purchase | this.is_generic_research) {
                    if (Object.prototype.hasOwnProperty.call(this.research_subs_dict, sd.part)) {
                        if (this.research_subs_dict[sd.part].includes(this.part_selected)) {
                            return true
                        }
                    }
                }
                return false
            },
            force_duplicate_search() {
                this.duplicate_reference = []

                let force_search = true
                this.search_stream(
                    this.parts_array,
                    this.quantity_array,
                    this.search_action_id,
                    this.search_type,
                    this.search_customer,
                    this.search_reference,
                    this.is_nsn,
                    this.includeGSA,
                    force_search
                )
            },
            closeReferenceModal() {
                this.duplicate_reference = []
                this.resetVars()
            },
            handleQuoteFinish() {
                this.resetVars()
                this.hideQuote()
                this.close_quote_modal()
            },
            handlePurchaseFinish() {
                this.resetVars()
                this.hidePurchase()
                this.close_purchase_modal()
            },
            handleCancelApproval() {
                this.remove_inv_vendor()
                this.hideQuote()
                this.close_approval_modal()
            },
            show_rule_details(rule_idx) {
                this.modal_rule = this.current_pricing_rules[rule_idx]
                document.getElementById('modal_price_rule').classList.add('is-active')
            },
            close_rule_details() {
                document.getElementById('modal_price_rule').classList.remove('is-active')
            },
            use_rule_price(price) {
                this.close_rule_details()
                this.q_quote = Number.parseFloat(price).toFixed(2)
                if (this.q_unit_cost > 0) {
                    this.q_margin = Number.parseFloat(
                        (this.q_quote / this.q_unit_cost - 1) * 100
                    ).toFixed(2)
                    this.quoteData[this.part_index]['margin_input'] = this.q_margin
                    if (this.q_quantity > 0) {
                        this.q_ext_quote = Number.parseFloat(
                            this.q_quote * this.q_quantity
                        ).toFixed(2)
                        this.quoteData[this.part_index]['ext_quote'] = this.q_ext_quote
                    }
                }
            },
            set_search_props(sa) {
                // Given a search action sa, set the search properties
                // Set search properties
                this.parts_array = sa.part_number_list
                this.search_type = sa.quote_type
                this.search_customer = sa.customer
                this.search_reference = sa.customer_ref
                this.parts_text = sa.part_number_list.join('\n')
                // Set store
                this.parts_array = sa.part_number_list
                let part_index = sa.part_number_list.indexOf(sa.searched_part)
                if (part_index >= 0) {
                    this.searchStore.set_part_selected(sa.part_number_list[part_index])
                    this.searchStore.set_part_index(part_index)
                } else {
                    this.searchStore.set_part_selected(sa.part_number_list[0])
                    this.searchStore.set_part_index(0)
                }
            },
            copyPartsToClipboard: async function () {
                // Check if API is available
                if (!navigator.clipboard) {
                    this.$toast.open({
                        message: 'Clipboard unavailable in this browser',
                        type: 'error',
                    })
                    return
                }
                // Get text
                let text = ''
                for (let part of this.parts_array) {
                    text += part + '\n'
                }
                text = text.trim()
                try {
                    await navigator.clipboard.writeText(text)
                    this.$toast.open({ message: 'Copied to clipboard', type: 'success' })
                } catch (err) {
                    this.$toast.open({ message: 'Failed copy', type: 'error' })
                }
                // Close Modal
                this.closePartsModal()
            },
            copyToClipboard: async function (text_element_id) {
                // Check if API is available
                if (!navigator.clipboard) {
                    this.$toast.open({
                        message: 'Clipboard unavailable in this browser',
                        type: 'error',
                    })
                    return
                }
                // Get text
                let el = document.getElementById(text_element_id)
                let text = el.value
                try {
                    await navigator.clipboard.writeText(text)
                    this.$toast.open({ message: 'Copied to clipboard', type: 'success' })
                } catch (err) {
                    this.$toast.open({ message: 'Failed copy', type: 'error' })
                }
                // Close Modal
                this.closePartsModal()
            },
            archive_sales_note(note_id) {
                let url = USER_NOTE_ARCHIVE
                let part = this.part_selected
                let sales_notes = this.sales_notes
                function archive_success(note_id, usernotearchive_id) {
                    this.$toast.open({ message: 'Note Archived', type: 'default' })
                    // Change note id data in sales notes
                    for (let nn in sales_notes) {
                        let all_notes = sales_notes[nn]
                        if ((all_notes.part == part) & (all_notes.note_type == 'sales')) {
                            let notes = all_notes.notes
                            for (let n in notes) {
                                let note = notes[n]
                                if (note.id == note_id) {
                                    note.usernotearchive_id = usernotearchive_id
                                }
                            }
                        }
                    }
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ note_id: note_id }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.usernotearchive_id) {
                            // Return a note object containing note/user/timestamp
                            archive_success(note_id, res.usernotearchive_id)
                        } else {
                            alert('Error: Archive error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            doDblClickQuote(vendor, table_row) {
                let this_quote = this.quoteData[this.part_index]

                // Check for inventory warehouse
                if (Object.prototype.hasOwnProperty.call(table_row, 'warehouse')) {
                    if (['JLS-BPA'].includes(table_row.warehouse)) {
                        this.show_approval_modal()
                    }
                    if (['GWG-KPNC'].includes(table_row.warehouse)) {
                        vendor = 'Greenwood Ponca KPNC'
                    }
                    if (['TXT-MP'].includes(table_row.warehouse)) {
                        vendor = 'Greenwood Ponca TXT'
                    }
                }
                // Add vendor
                this.q_vendor = vendor
                this_quote.vendor = vendor

                // Part number
                this.q_part_number = this.part_selected
                if (Object.prototype.hasOwnProperty.call(table_row, 'part_number')) {
                    let part_quoted = table_row.part_number
                    this.q_part_quoted = part_quoted
                    this_quote.part_quoted = part_quoted
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'PartNumber')) {
                    let part_quoted = table_row.PartNumber
                    this.q_part_quoted = part_quoted
                    this_quote.part_quoted = part_quoted
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'PartNum')) {
                    let part_quoted = table_row.Part_Num
                    this.q_part_quoted = part_quoted
                    this_quote.part_quoted = part_quoted
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'part_num')) {
                    let part_quoted = table_row.part_num
                    this.q_part_quoted = part_quoted
                    this_quote.part_quoted = part_quoted
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'pn')) {
                    let part_quoted = table_row.pn
                    this.q_part_quoted = part_quoted
                    this_quote.part_quoted = part_quoted
                }
                // List Price
                if (Object.prototype.hasOwnProperty.call(table_row, 'list_price')) {
                    let list = table_row.list_price.replace(/[^\d.]/g, '')
                    this.q_list_price = list
                    this_quote.list_price = list
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'listprice')) {
                    let list = table_row.listprice.replace(/[^\d.]/g, '')
                    this.q_list_price = list
                    this_quote.list_price = list
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'netPrice')) {
                    let list = table_row.netPrice.replace(/[^\d.]/g, '')
                    this.q_list_price = list
                    this_quote.list_price = list
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'price')) {
                    let list = table_row.price.replace(/[^\d.]/g, '')
                    this.q_list_price = list
                    this_quote.list_price = list
                    if (['AeroFastener', 'Boeing Distribution'].includes(vendor)) {
                        this.q_unit_cost = list
                        this_quote.unit_cost = list
                    }
                }
                // Inventory Component
                if (Object.prototype.hasOwnProperty.call(table_row, 'description')) {
                    this.q_description = table_row.description
                    this_quote.description = table_row.description
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'unit_cost')) {
                    let raw_cost = table_row.unit_cost
                    let ucost = raw_cost.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                    // Check for margin data in inventory table
                    if (vendor.includes('Greenwood Ponca') | vendor.includes('GlobalParts')) {
                        if (Object.prototype.hasOwnProperty.call(table_row, 'min_margin')) {
                            var bulk_data
                            if (table_row.min_margin != null) {
                                bulk_data = this.setBulkPricing(
                                    table_row.min_margin,
                                    table_row.min_margin_vendor
                                )
                            } else {
                                bulk_data = this.setBulkPricing(0, table_row.min_margin_vendor)
                            }
                            let replacement_cost = bulk_data[0]
                            let replacement_list_price = bulk_data[3]
                            this.q_unit_cost = replacement_cost
                            this_quote.unit_cost = replacement_cost
                            this.q_list_price = replacement_list_price
                            this_quote.list_price = replacement_list_price
                            // if(margin_percent > 0){
                            //   this.q_margin = margin_percent
                            //   this_quote.margin = margin_percent
                            // }
                        } else {
                            let bulk_data = this.setBulkPricing(0, null)
                            let replacement_cost = bulk_data[0]
                            let replacement_list_price = bulk_data[3]
                            this.q_unit_cost = replacement_cost
                            this_quote.unit_cost = replacement_cost
                            this.q_list_price = replacement_list_price
                            this_quote.list_price = replacement_list_price
                        }
                    } else {
                        let raw_cost = table_row.unit_cost
                        let ucost = raw_cost.replace(/[^\d.]/g, '')
                        if (ucost != '') {
                            this.q_unit_cost = ucost
                            this_quote.unit_cost = ucost
                        }
                    }
                }
                //AeroPerformance
                if (Object.prototype.hasOwnProperty.call(table_row, 'netprice')) {
                    let ucost = table_row.netprice.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                } else if (Object.prototype.hasOwnProperty.call(table_row, 'listprice')) {
                    let raw_cost = table_row.listprice
                    let ucost = raw_cost.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                }
                // Boeing/Aviall
                if (Object.prototype.hasOwnProperty.call(table_row, 'netPrice')) {
                    let ucost = table_row.netPrice.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                }
                // Textron and Textron Defense and Boeing
                if (Object.prototype.hasOwnProperty.call(table_row, 'name')) {
                    this.q_description = table_row.name
                    this_quote.description = table_row.name
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'part_desc')) {
                    this.q_description = table_row.part_desc
                    this_quote.description = table_row.part_desc
                }
                // Textron and Textron Defense and AeroPerformance
                if (
                    Object.prototype.hasOwnProperty.call(table_row, 'your_price') &&
                    Object.prototype.hasOwnProperty.call(table_row, 'core_deposit')
                ) {
                    let deposit = table_row.core_deposit.replace(/[^\d.]/g, '')
                    let price = table_row.your_price.replace(/[^\d.]/g, '')
                    let ucost = Number(price) + Number(deposit)
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                    this.q_core = deposit
                    this_quote.core = deposit
                } else if (
                    Object.prototype.hasOwnProperty.call(table_row, 'your_price') &&
                    Object.prototype.hasOwnProperty.call(table_row, 'CoreDeposit')
                ) {
                    let deposit = table_row.CoreDeposit.replace(/[^\d.]/g, '')
                    let price = table_row.your_price.replace(/[^\d.]/g, '')
                    let ucost = Number(price) + Number(deposit)
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                    this.q_core = deposit
                    this_quote.core = deposit
                } else if (
                    Object.prototype.hasOwnProperty.call(table_row, 'netprice') &&
                    Object.prototype.hasOwnProperty.call(table_row, 'core')
                ) {
                    let deposit = 0
                    if (table_row.core) {
                        deposit = table_row.core.replace(/[^\d.]/g, '')
                    }
                    let price = table_row.netprice.replace(/[^\d.]/g, '')
                    let ucost = Number(price) + Number(deposit)
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                    this.q_core = deposit
                    this_quote.core = deposit
                } else if (Object.prototype.hasOwnProperty.call(table_row, 'your_price')) {
                    let ucost = table_row.your_price.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                }
                // Textron API
                if (Object.prototype.hasOwnProperty.call(table_row, 'Desc')) {
                    this.q_description = table_row.Desc
                    this_quote.description = table_row.Desc
                }
                if (
                    Object.prototype.hasOwnProperty.call(table_row, 'Price') &&
                    Object.prototype.hasOwnProperty.call(table_row, 'CoreDeposit')
                ) {
                    let deposit = table_row.CoreDeposit.replace(/[^\d.]/g, '')
                    let price = table_row.Price.replace(/[^\d.]/g, '')
                    let ucost = Number(price) + Number(deposit)
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                } else if (Object.prototype.hasOwnProperty.call(table_row, 'Price')) {
                    let ucost = table_row.Price.replace(/[^\d.]/g, '')
                    this.q_unit_cost = ucost
                    this_quote.unit_cost = ucost
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'lead_time')) {
                    let lead_time = table_row.lead_time.replace(/[^\d.]/g, '')
                    this.q_lead_time = lead_time
                    this_quote.lead_time = lead_time
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'unit_of_measure')) {
                    let unit_of_measure = table_row.unit_of_measure
                    this.q_unit_of_measure = unit_of_measure
                    this_quote.unit_of_measure = unit_of_measure
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'uom')) {
                    let unit_of_measure = table_row.uom
                    this.q_unit_of_measure = unit_of_measure
                    this_quote.unit_of_measure = unit_of_measure
                }

                // Display quote_form
                this.showQuote()
                this.calcQuote()
            },
            doDblClickPurchase(vendor, table_row) {
                let this_purchase = this.purchaseData[this.part_index]
                // Add vendor
                this.p_vendor = vendor
                this_purchase.vendor = vendor
                // Part number
                if (Object.prototype.hasOwnProperty.call(table_row, 'part_number')) {
                    this.q_part_number = table_row.part_number
                    this.p_part_number = table_row.part_number
                }
                // Inventory Component
                if (Object.prototype.hasOwnProperty.call(table_row, 'description')) {
                    this.p_description = table_row.description
                    this_purchase.description = table_row.description
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'unit_cost')) {
                    let ucost = table_row.unit_cost.replace(/[^\d.]/g, '')
                    this.p_unit_cost = ucost
                    this_purchase.unit_cost = ucost
                }
                // Boeing/Aviall
                if (Object.prototype.hasOwnProperty.call(table_row, 'netPrice')) {
                    let ucost = table_row.netPrice.replace(/[^\d.]/g, '')
                    this.p_unit_cost = ucost
                    this_purchase.unit_cost = ucost
                }
                // Textron and Textron Defense
                if (Object.prototype.hasOwnProperty.call(table_row, 'part_desc')) {
                    this.p_description = table_row.part_desc
                    this_purchase.description = table_row.part_desc
                }
                if (
                    Object.prototype.hasOwnProperty.call(table_row, 'your_price') &&
                    Object.prototype.hasOwnProperty.call(table_row, 'core_deposit')
                ) {
                    let deposit = table_row.core_deposit.replace(/[^\d.]/g, '')
                    let price = table_row.your_price.replace(/[^\d.]/g, '')
                    let ucost = Number(price) + Number(deposit)
                    this.p_unit_cost = ucost
                    this_purchase.unit_cost = ucost
                } else if (Object.prototype.hasOwnProperty.call(table_row, 'your_price')) {
                    let ucost = table_row.your_price.replace(/[^\d.]/g, '')
                    this.p_unit_cost = ucost
                    this_purchase.unit_cost = ucost
                }
                if (Object.prototype.hasOwnProperty.call(table_row, 'unit_of_measure')) {
                    let unit_of_measure = table_row.your_price.replace(/[^\d.]/g, '')
                    this.p_unit_of_measure = unit_of_measure
                    this_purchase.unit_of_measure = unit_of_measure
                }

                // Display purchase_form
                this.showPurchase()
            },
            onRowDblClick(args) {
                // On datatable double click, add values from table to the appropriate sources.
                // For quotes:
                //   - quote_form
                //   - quoteData
                // For purchases:
                //   - purchase_form
                //   - purchaseData
                // ONLY if vendor matches allowed clickable_vendors
                if (this.generic_research_only) {
                    // Rows are not clickable in generic research mode
                    return
                }
                const clickable_vendors = [
                    'Textron',
                    'Textron Defense',
                    'Boeing/Aviall',
                    'GlobalParts Inventory',
                    'Greenwood Ponca Inventory',
                    'Aero Performance',
                    'AeroFastener',
                    'Boeing Distribution',
                ]
                let vendor = args.vendor
                if (clickable_vendors.includes(vendor)) {
                    let table_row = args.row
                    if (this.research_purchases_only) {
                        this.doDblClickPurchase(vendor, table_row)
                    } else {
                        this.doDblClickQuote(vendor, table_row)
                    }
                }
            },
            onRowPartDbDblClick(args) {
                let table_row = args.row
                let vendor = table_row.source
                this.doDblClickQuote(vendor, table_row)
            },
            edit_quote(e) {
                let id = e.target.id.slice(2) //remove "q_" from id name
                let val = e.target.value
                this.quoteData[this.part_index][id] = val
                this.calcQuote(e)
            },
            edit_quote_vendor(vendor) {
                if (this.part_index in this.quoteData) {
                    this.quoteData[this.part_index]['vendor'] = vendor
                }
            },
            edit_purchase(e) {
                let id = e.target.id.slice(2) //remove "p_" from id name
                let val = e.target.value
                this.purchaseData[this.part_index][id] = val
            },
            edit_purchase_vendor(vendor) {
                if (this.part_index in this.purchaseData) {
                    this.purchaseData[this.part_index]['vendor'] = vendor
                }
            },
            toggle_quote_submit(no_quote = false) {
                let submit = document.getElementById('quote_submit')
                let quote_none = document.getElementById('quote_none')
                if (submit.disabled == false) {
                    submit.disabled = true
                    quote_none.disabled = true
                    if (no_quote) {
                        quote_none.classList.add('is-loading')
                    } else {
                        submit.classList.add('is-loading')
                    }
                } else {
                    submit.disabled = false
                    submit.classList.remove('is-loading')
                    quote_none.disabled = false
                    quote_none.classList.remove('is-loading')
                }
            },
            no_quote(part, q_no_quote_reason) {
                if (q_no_quote_reason == '' || q_no_quote_reason == null) {
                    alert('Please select a reason.')
                    return
                }
                // Add search action id to dict
                this.sync_quote_data()
                let idx = this.part_index
                this.close_no_quote_modal()
                this.toggle_quote_submit(true)
                // this.quoteData[idx]['search_action_id'] = this.search_action_id
                this.quoteData[idx]['no_quote'] = true
                this.quoteData[idx]['submitted'] = true
                let current_notes = this.quoteData[idx]['notes']
                if (current_notes == null) {
                    this.quoteData[idx]['notes'] = 'No quote: ' + q_no_quote_reason
                } else if (current_notes.trim() != '') {
                    this.quoteData[idx]['notes'] =
                        'No quote: ' + q_no_quote_reason + ' | ' + current_notes
                } else {
                    this.quoteData[idx]['notes'] = 'No quote: ' + q_no_quote_reason
                }
                this.ajax_submit_quote(this.quoteData[idx], part)
            },
            insert_previous_quote_values() {
                let idx = this.part_index
                let part_data = this.quoteData[idx]
                // Make matching part numbers have the same data.
                // But keep original quantities!
                for (let prev_quote of this.quoteData) {
                    if (prev_quote.part_number == part_data.part_number) {
                        for (const [key, value] of Object.entries(prev_quote)) {
                            if ((key != 'quantity') & (key != 'id')) {
                                part_data[key] = value
                            }
                        }
                    }
                }
                // Trigger part change to update form view
                this.partChange()
                this.showQuote()
            },
            submit_quote(part) {
                this.toggle_quote_submit()
                // Add search action id to dict
                this.sync_quote_data()
                let idx = this.part_index
                this.quoteData[idx]['no_quote'] = false
                this.quoteData[idx]['submitted'] = true
                let part_data = this.quoteData[idx]
                this.ajax_submit_quote(part_data, part)
            },
            toggle_purchase_submit(no_purchase = false) {
                let submit = document.getElementById('purchase_submit')
                let purchase_none = document.getElementById('purchase_none')
                if (submit.disabled == false) {
                    submit.disabled = true
                    purchase_none.disabled = true
                    if (no_purchase) {
                        purchase_none.classList.add('is-loading')
                    } else {
                        submit.classList.add('is-loading')
                    }
                } else {
                    submit.disabled = false
                    submit.classList.remove('is-loading')
                    purchase_none.disabled = false
                    purchase_none.classList.remove('is-loading')
                }
            },
            no_purchase(part) {
                this.toggle_purchase_submit(true)
                // Add search action id to dict
                this.sync_purchase_data()
                let idx = this.part_index
                // this.purchaseData[idx]['search_action_id'] = this.search_action_id
                this.purchaseData[idx]['no_purchase'] = true
                this.purchaseData[idx]['submitted'] = true
                this.ajax_submit_purchase(this.purchaseData[idx], part)
            },
            submit_purchase(part) {
                this.toggle_purchase_submit()
                // Add search action id to dict
                this.sync_purchase_data()
                let idx = this.part_index
                // this.purchaseData[idx]['search_action_id'] = this.search_action_id
                this.purchaseData[idx]['no_purchase'] = false
                this.purchaseData[idx]['submitted'] = true
                this.ajax_submit_purchase(this.purchaseData[idx], part)
            },
            download_quote_data() {
                let quoteData = this.quoteData
                let df = new DataFrame(quoteData)
                // Add 2 columns
                df = df
                    .withColumn('Line Item', (row, index) => index + 1)
                    .withColumn('ext_cost', (row) => row.get('unit_cost') * row.get('quantity'))
                df = df.select(
                    'Line Item',
                    'customer',
                    'quote_type',
                    'part_number',
                    'part_quoted',
                    'description',
                    'quantity',
                    'unit_of_measure',
                    'quote',
                    'ext_quote',
                    'lead_time',
                    'notes',
                    'no_quote',
                    'vendor',
                    'unit_cost',
                    'ext_cost'
                )
                // Format NO QUOTE field
                df = df.map((row) => {
                    let val = row.get('no_quote')
                    if (val === false) {
                        return row.set('no_quote', '')
                    } else if (val === true) {
                        return row.set('no_quote', 'NO QUOTE')
                    }
                })
                // Rename rows
                df = df
                    .rename('customer', 'Customer')
                    .rename('quote_type', 'Quote Type')
                    .rename('part_number', 'Part Number')
                    .rename('part_quoted', 'Part Quoted')
                    .rename('description', 'Description')
                    .rename('quantity', 'Quantity')
                    .rename('unit_of_measure', 'UOM')
                    .rename('quote', 'Quote')
                    .rename('ext_quote', 'Ext Quote')
                    .rename('lead_time', 'Lead Time (Days)')
                    .rename('notes', 'Notes')
                    .rename('vendor', 'Vendor')
                    .rename('no_quote', 'No Quote')
                    .rename('unit_cost', 'Unit Cost')
                    .rename('ext_cost', 'Ext Cost')

                let csv = df.toCSV(df)
                let csvContent = 'data:text/csv;charset=utf-8,' + csv
                let encodedUri = encodeURI(csvContent)
                encodedUri = encodedUri.replace(/#/g, '%23') // Replace pound sign

                var element = document.createElement('a')
                element.setAttribute('href', encodedUri)
                let m = moment()
                let date = m.format('YYYY-MM-DD')
                element.setAttribute(
                    'download',
                    date +
                        '_' +
                        this.search_type +
                        '_' +
                        this.search_customer +
                        '_' +
                        this.search_reference +
                        '.csv'
                )

                element.style.display = 'none'
                document.body.appendChild(element)

                element.click()

                document.body.removeChild(element)
            },
            download_purchase_data() {
                let df = new DataFrame(this.purchaseData)
                df = df.select(
                    'part_number',
                    'description',
                    'unit_cost',
                    'vendor',
                    'quantity',
                    'unit_of_measure',
                    'notes',
                    'no_purchase'
                )
                df = df
                    .rename('part_number', 'Part Number')
                    .rename('description', 'Description')
                    .rename('unit_cost', 'Unit Cost')
                    .rename('unit_of_measure', 'UOM')
                    .rename('quantity', 'Quantity')
                    .rename('vendor', 'Vendor')
                    .rename('notes', 'Notes')
                    .rename('no_purchase', 'No Purchase')
                let csv = df.toCSV(df)
                let csvContent = 'data:text/csv;charset=utf-8,' + csv
                let encodedUri = encodeURI(csvContent)
                encodedUri = encodedUri.replace(/#/g, '%23') // Replace pound sign

                var element = document.createElement('a')
                element.setAttribute('href', encodedUri)
                let m = moment()
                let date = m.format('YYYY-MM-DD_HH_mm')
                element.setAttribute('download', date + '_' + 'purchase.csv')

                element.style.display = 'none'
                document.body.appendChild(element)

                element.click()

                document.body.removeChild(element)
            },
            show_quote_modal() {
                // Test whether all quotes were submitted
                let unsubmitted_parts = []
                for (let i = 0; i < this.parts_array.length; i++) {
                    let this_part = this.parts_array[i]
                    if (Object.prototype.hasOwnProperty.call(this.quoteData[i], 'submitted')) {
                        if (this.quoteData[i]['submitted'] == false) {
                            unsubmitted_parts.push(this_part)
                        }
                    } else {
                        unsubmitted_parts.push(this_part)
                    }
                }
                if (unsubmitted_parts.length == 0) {
                    document.getElementById('quote_modal').classList.add('is-active')
                } else {
                    let html_list = ''
                    for (let idx in unsubmitted_parts) {
                        html_list += '<li>' + unsubmitted_parts[idx] + '</li>'
                    }
                    document.getElementById('quote_fail_list').innerHTML = html_list
                    document.getElementById('quote_fail_modal').classList.add('is-active')
                }
            },
            close_quote_modal() {
                document.getElementById('quote_modal').classList.remove('is-active')
                document.getElementById('quote_fail_modal').classList.remove('is-active')
                document.getElementById('quote_fail_list').innerHTML = ''
            },
            show_purchase_modal() {
                // Test whether all purchases were submitted
                let unsubmitted_parts = []
                for (let i = 0; i < this.parts_array.length; i++) {
                    let this_part = this.parts_array[i]
                    if (Object.prototype.hasOwnProperty.call(this.purchaseData[i], 'submitted')) {
                        if (this.purchaseData[i]['submitted'] == false) {
                            unsubmitted_parts.push(this_part)
                        }
                    } else {
                        unsubmitted_parts.push(this_part)
                    }
                }
                if (unsubmitted_parts.length == 0) {
                    document.getElementById('purchase_modal').classList.add('is-active')
                } else {
                    let html_list = ''
                    for (let idx in unsubmitted_parts) {
                        html_list += '<li>' + unsubmitted_parts[idx] + '</li>'
                    }
                    document.getElementById('purchase_fail_list').innerHTML = html_list
                    document.getElementById('purchase_fail_modal').classList.add('is-active')
                }
            },
            remove_inv_vendor() {
                this.q_vendor = ''
                let idx = this.part_index
                this.quoteData[idx]['vendor'] = this.q_vendor
            },
            close_purchase_modal() {
                document.getElementById('purchase_modal').classList.remove('is-active')
                document.getElementById('purchase_fail_modal').classList.remove('is-active')
                document.getElementById('purchase_fail_list').innerHTML = ''
            },
            show_no_quote_modal() {
                document.getElementById('no_quote_modal').classList.add('is-active')
            },
            close_no_quote_modal() {
                document.getElementById('no_quote_modal').classList.remove('is-active')
                this.q_no_quote_reason = ''
            },
            show_approval_modal() {
                document.getElementById('approval_modal').classList.add('is-active')
            },
            close_approval_modal() {
                document.getElementById('approval_modal').classList.remove('is-active')
            },
            show_pricing_action_modal() {
                document.getElementById('pricing_action_modal').classList.add('is-active')
            },
            close_pricing_action_modal() {
                document.getElementById('pricing_action_modal').classList.remove('is-active')
            },
            show_pricing_action_reason_modal() {
                document.getElementById('pricing_action_reason_modal').classList.add('is-active')
            },
            close_pricing_action_reason_modal() {
                document.getElementById('pricing_action_reason_modal').classList.remove('is-active')
            },
            pricing_action_use_suggested() {
                // Called from pricing action modal
                // Use the system suggested price and submit the quote
                this.q_quote = this.pa_suggested_price
                this.quoteData[this.part_index]['quote'] = this.pa_suggested_price
                this.calcQuote('pricing_action')
                this.close_pricing_action_modal()
                this.submit_quote(this.part_selected)
            },
            sync_quote_data() {
                let idx = this.part_index
                this.quoteData[idx]['part_quoted'] = this.q_part_quoted
                this.quoteData[idx]['description'] = this.q_description
                this.quoteData[idx]['quantity'] = this.q_quantity
                this.quoteData[idx]['vendor'] = this.q_vendor
                this.quoteData[idx]['list_price'] = this.q_list_price
                this.quoteData[idx]['unit_cost'] = this.q_unit_cost
                this.quoteData[idx]['margin_input'] = this.q_margin
                this.quoteData[idx]['quote'] = this.q_quote
                this.quoteData[idx]['ext_quote'] = this.q_ext_quote
                this.quoteData[idx]['notes'] = this.q_notes
                this.quoteData[idx]['lead_time'] = this.q_lead_time
                this.quoteData[idx]['unit_of_measure'] = this.q_unit_of_measure
                this.quoteData[idx]['exchange'] = this.q_exchange
                this.quoteData[idx]['core'] = this.q_core
                this.quoteData[idx]['extra_charge_type'] = this.q_extra_charge_type
                this.quoteData[idx]['extra_charge'] = this.q_extra_charge
                this.quoteData[idx]['no_quote_reason'] = this.q_no_quote_reason
            },
            sync_purchase_data() {
                let idx = this.part_index
                this.purchaseData[idx]['description'] = this.p_description
                this.purchaseData[idx]['quantity'] = this.p_quantity
                this.purchaseData[idx]['vendor'] = this.p_vendor
                this.purchaseData[idx]['unit_cost'] = this.p_unit_cost
                this.purchaseData[idx]['notes'] = this.p_notes
                this.purchaseData[idx]['unit_of_measure'] = this.p_unit_of_measure
            },
            is_valid_purchase(purchase_data) {
                // Check whether all fields have value.
                // If good, return true, otherwise false
                if (purchase_data['no_purchase'] == true) {
                    return true
                }
                for (const prop in purchase_data) {
                    let val = purchase_data[prop]
                    if (typeof val == 'string') {
                        val = val.trim()
                        if (val == '') {
                            return false
                        }
                    }
                }
                return true
            },
            is_valid_quote(quote_data) {
                // Check whether all fields have value.
                // If good, return true, otherwise false
                if (quote_data['no_quote'] == true) {
                    return true
                }
                let field_check = [
                    'part_number',
                    'part_quoted',
                    'description',
                    'ext_quote',
                    'margin_input',
                    'quantity',
                    'quote',
                    'unit_cost',
                    'vendor',
                    'cost',
                    'list_price',
                ]
                for (const prop in quote_data) {
                    if (field_check.includes(prop)) {
                        let val = quote_data[prop]
                        if (val == null) {
                            return false
                        }
                        if (typeof val == 'string') {
                            val = val.trim()
                            if (val == '') {
                                return false
                            }
                        }
                    }
                }
                return true
            },
            ajax_finish_quote() {
                let url = SEARCHACTION_FINISH
                let sa_id = this.search_action_id
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ search_action: sa_id, quote_finished: true }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            // Return the part number and quote_id of the created/updated record
                            this.$toast.open({ message: 'Quote Finished', type: 'default' })
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            set_pricing_action_data(pricing_action) {
                this.pa_suggested_price = pricing_action.suggested_price
                this.pa_suggested_margin = pricing_action.suggested_margin
                this.pa_description = pricing_action.description
                this.pa_id = pricing_action.pa_id
            },
            ajax_submit_quote(quote_data) {
                let part_index = this.part_index
                let is_valid = this.is_valid_quote(quote_data)
                if (is_valid == false) {
                    alert('Please enter a value in all fields before submitting the quote.')
                    this.toggle_quote_submit()
                    return
                }
                let url = QUOTE_CREATE
                let toggle_quote_submit = this.toggle_quote_submit
                let hideQuote = this.hideQuote
                let nextPart = this.nextPart
                let parts_array = this.searchStore.parts_array
                let show_quote_modal = this.show_quote_modal
                let all_quotes = this.quoteData
                let ajax_finish_quote = this.ajax_finish_quote
                let search_action_id = this.search_action_id
                let searching = this.searching
                let set_pricing_action_data = this.set_pricing_action_data
                let show_pricing_action_modal = this.show_pricing_action_modal
                // let this_quote = this.quoteData[part]
                function append_quote_id_check_price(quote_id, pricing_action) {
                    quote_data['id'] = quote_id
                    if (pricing_action) {
                        if (pricing_action.meets_criteria == false) {
                            set_pricing_action_data(pricing_action)
                            show_pricing_action_modal()
                            toggle_quote_submit()
                            return
                        }
                    }
                    toggle_quote_submit()
                    hideQuote()
                    nextPart()
                    // Test if we're on the last part
                    if (part_index == parts_array.length - 1) {
                        // If all quotes are submitted, then finish the quote
                        for (let idx in all_quotes) {
                            var is_finished = all_quotes[idx].submitted
                            if (!is_finished) {
                                break
                            }
                        }
                        if (is_finished) {
                            ajax_finish_quote(search_action_id)
                        }

                        // Show quote modal if done searching
                        if (searching) {
                            alert('Please let search finish before submitting final quote.')
                        } else {
                            show_quote_modal()
                        }
                    }
                }
                function quote_fail() {
                    toggle_quote_submit()
                    alert('Error saving quote')
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(quote_data),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (Object.prototype.hasOwnProperty.call(res, 'id')) {
                            // Return the part number and quote_id of the created/updated record
                            let quote_id = res.id
                            let pricing_action = res.pricing_action
                            append_quote_id_check_price(quote_id, pricing_action)

                            this.$toast.open({ message: 'Quote Saved', type: 'default' })
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                        quote_fail()
                    })
            },
            ajax_pa_update_reason() {
                let search_action_id = this.search_action_id
                let part_index = this.part_index
                let parts_array = this.searchStore.parts_array
                let all_quotes = this.quoteData
                let show_quote_modal = this.show_quote_modal
                let searching = this.searching
                let quote_id = all_quotes[part_index]['id']
                let url = QUOTE_UPDATE_REASON
                let user_reason = this.pa_reason
                let ajax_finish_quote = this.ajax_finish_quote
                let nextPart = this.nextPart
                let hideQuote = this.hideQuote
                let close_pricing_action_modal = this.close_pricing_action_modal
                let close_pricing_action_reason_modal = this.close_pricing_action_reason_modal
                function quote_fail() {
                    alert('Error saving quote')
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ quote_id: quote_id, user_reason: user_reason }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success == true) {
                            nextPart()
                            hideQuote()
                            close_pricing_action_modal()
                            close_pricing_action_reason_modal()
                            // Test if we're on the last part
                            if (part_index == parts_array.length - 1) {
                                // If all quotes are submitted, then finish the quote
                                for (let idx in all_quotes) {
                                    var is_finished = all_quotes[idx].submitted
                                    if (!is_finished) {
                                        break
                                    }
                                }
                                if (is_finished) {
                                    ajax_finish_quote(search_action_id)
                                }

                                // Show quote modal if done searching
                                if (searching) {
                                    alert('Please let search finish before submitting final quote.')
                                } else {
                                    show_quote_modal()
                                }
                            }
                            this.$toast.open({ message: 'Reason Saved', type: 'default' })
                        } else {
                            alert('Error: Error updating reason')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                        quote_fail()
                    })
            },
            ajax_submit_purchase(purchase_data) {
                let part_index = this.part_index
                let is_valid = this.is_valid_purchase(purchase_data)
                if (is_valid == false) {
                    alert('Please enter a value in all fields before submitting the purchase.')
                    this.toggle_purchase_submit()
                    return
                }
                let url = PURCHASE_RESEARCH_CREATE
                let toggle_purchase_submit = this.toggle_purchase_submit
                let hidePurchase = this.hidePurchase
                let nextPart = this.nextPart
                let parts_array = this.searchStore.parts_array
                let show_purchase_modal = this.show_purchase_modal

                function append_purchase_id(purchase_id) {
                    purchase_data['id'] = purchase_id
                    toggle_purchase_submit()
                    hidePurchase()
                    nextPart()
                    // Test if we're on the last part
                    if (part_index == parts_array.length - 1) {
                        show_purchase_modal()
                    }
                }
                function purchase_fail() {
                    toggle_purchase_submit()
                    alert('Error saving purchase')
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify(purchase_data),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (Object.prototype.hasOwnProperty.call(res, 'id')) {
                            // Return the part number and purchase_id of the created/updated record
                            let purchase_id = res.id
                            append_purchase_id(purchase_id)

                            this.$toast.open({ message: 'Purchase Saved', type: 'default' })
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                        purchase_fail()
                    })
            },
            add_user_note() {
                document.getElementById('user_note_modal').classList.add('is-active')
            },
            save_user_note() {
                let textarea = document.getElementById('usernote_text')
                // eslint-disable-next-line no-unused-vars
                let new_note = textarea.value
                this.ajax_add_user_note(new_note)
                textarea.value = ''
                this.closeModal('user_note_modal')
            },
            add_admin_note() {
                document.getElementById('admin_note_modal').classList.add('is-active')
            },
            save_admin_note() {
                let textarea = document.getElementById('adminnote_text')
                // eslint-disable-next-line no-unused-vars
                let new_note = textarea.value
                this.ajax_add_admin_note(new_note)
                textarea.value = ''
                this.closeModal('admin_note_modal')
            },
            closeModal(modal_id) {
                document.getElementById(modal_id).classList.remove('is-active')
            },
            showPartsModal() {
                let modal = document.getElementById('modal_show_parts')
                let text = document.getElementById('show_parts_text')
                text.value = ''
                for (let part of this.parts_array) {
                    text.value += part + '\n'
                }
                modal.classList.add('is-active')
            },
            closePartsModal() {
                let modal = document.getElementById('modal_show_parts')
                let text = document.getElementById('show_parts_text')
                text.value = ''
                modal.classList.remove('is-active')
            },
            showEditPartModal() {
                function reset_modal(this_vue) {
                    //reset modal values
                    this_vue.provisional_parts_array = [...this_vue.parts_array] // Copy of array
                    document.getElementById('edit_part_select').value = ''
                    document.getElementById('edit_part_input').value = ''
                    document.getElementById('edit_part_list').innerHTML = ''
                }
                let modal = document.getElementById('modal_edit_part')
                // Open the modal and reset values
                reset_modal(this)
                modal.classList.add('is-active')
            },
            closeEditPartModal() {
                function reset_modal(this_vue) {
                    //reset modal values
                    this_vue.provisional_parts_array = [...this_vue.parts_array] // Copy of array
                    document.getElementById('edit_part_select').value = ''
                    document.getElementById('edit_part_input').value = ''
                    document.getElementById('edit_part_list').innerHTML = ''
                }
                let modal = document.getElementById('modal_edit_part')
                // Close the modal and reset values
                reset_modal(this)
                modal.classList.remove('is-active')
            },
            showEditCustRefModal() {
                let modal = document.getElementById('modal_edit_customer_reference')
                // Open the modal and set values
                this.modal_input_customer = this.search_customer
                document.getElementById('modal_input_reference').value = this.search_reference
                modal.classList.add('is-active')
            },
            closeEditCustRefModal() {
                let modal = document.getElementById('modal_edit_customer_reference')
                modal.classList.remove('is-active')
            },
            editCustomerReference() {
                let customer = this.modal_input_customer
                let reference = document.getElementById('modal_input_reference').value
                this.closeEditCustRefModal()
                this.ajax_edit_searchaction_customer_reference(customer, reference)
            },
            editProvisionalPartsArray() {
                // Get index of selected part and change value in provisional array
                let p_idx = document.getElementById('edit_part_select').value
                let val = document.getElementById('edit_part_input').value
                this.provisional_parts_array[p_idx] = val.toUpperCase().replace(/[ \t\n]+/, ' ') // Upper case and single spaces

                // Display any differences between current and provisional arrays
                let list = document.getElementById('edit_part_list')
                list.innerHTML = ''
                for (let idx in this.parts_array) {
                    let curr_part = this.parts_array[idx]
                    let prov_part = this.provisional_parts_array[idx]
                    if (curr_part != prov_part) {
                        list.innerHTML += `<div  style="display:flex; flex-direction:row; justify-content:center; margin-bottom:0.5rem;" >
                              <span>${curr_part}</span><span class="material-icons" style="color:#3298dc; margin:0 1.5rem;">arrow_right_alt</span> <span>${prov_part}</span>
                              </div>`
                    }
                }

                // Reset the input state
                document.getElementById('edit_part_select').value = ''
                document.getElementById('edit_part_input').value = ''
            },
            get_part_changes: async function (parts_array, provisional_parts_array) {
                // Get all part changes and return an object where
                // key=index and value=part_number
                let changed_parts_dict = {}
                let new_parts_list = []
                for (let idx in parts_array) {
                    let curr_part = parts_array[idx]
                    let prov_part = provisional_parts_array[idx]
                    if (curr_part != prov_part) {
                        changed_parts_dict[idx] = prov_part
                        if (!parts_array.includes(prov_part)) {
                            // Only search for new parts if they
                            // are not in the original parts_array
                            new_parts_list.push(prov_part)
                        }
                    }
                }
                let new_parts_list_unique = [...new Set(new_parts_list)]
                return {
                    changed_parts_dict: changed_parts_dict,
                    new_parts_list: new_parts_list_unique,
                }
            },
            check_not_searching: async function () {
                if (this.searching) {
                    this.$toast.open({ message: 'Waiting for current search...', type: 'default' })
                }
                let this_vue = this
                return new Promise(function (resolve) {
                    // eslint-disable-next-line
                    ;(function waitForSearch() {
                        if (!this_vue.searching) return resolve()
                        setTimeout(waitForSearch, 500)
                    })()
                })
            },
            editPartsArray: async function () {
                let change_data = await this.get_part_changes(
                    this.parts_array,
                    this.provisional_parts_array
                )
                let changed_parts_dict = change_data['changed_parts_dict']
                // eslint-disable-next-line no-unused-vars
                let new_parts_list = change_data['new_parts_list']

                if (new_parts_list.length > 0) {
                    let original_parts = [...this.parts_array]
                    // Edit the parts array
                    this.parts_array = [...this.provisional_parts_array]

                    // Close the modal dialog box
                    this.closeEditPartModal()
                    this.closeFuzzyMatchModal()

                    // Wait until other searches complete to do this search
                    await this.check_not_searching()
                    // Show toast
                    this.$toast.open({ message: 'Searching edited parts', type: 'default' })

                    // Edit search action parts
                    await this.ajax_edit_search_action_parts(
                        this.search_action_id,
                        original_parts,
                        new_parts_list,
                        changed_parts_dict
                    )

                    // Edit individual quote part (frontend)
                    // And get quote_ids for all edited parts
                    // to update in the backend
                    let quote_edits = []
                    let idxs = Object.keys(changed_parts_dict)
                    for (let idx of idxs) {
                        let new_part = changed_parts_dict[idx]
                        this.quoteData[idx].part_number = new_part
                        quote_edits.push({
                            quote_id: this.quoteData[idx].id,
                            part_number: new_part,
                        })
                    }

                    // Edit individual quote part_number (backend)
                    // Send array of dicts [{quote_id, part_number}, {}, ...]
                    await this.ajax_edit_quote_part(quote_edits)

                    // Look for new data (and erase old)
                    this.partChange()

                    // Search for edited parts (force_search=true to make sure we don't get a duplicate reference dialog)
                    let force_search = true
                    this.search_stream(
                        new_parts_list,
                        [],
                        this.search_action_id,
                        this.search_type,
                        this.search_customer,
                        this.search_reference,
                        this.is_nsn,
                        this.includeGSA,
                        force_search
                    )
                } else {
                    alert('No parts have been edited. Be sure to click "Edit" before searching.')
                }

                return
            },
            showQuote() {
                let form = document.getElementById('quote_form')
                form.style.display = 'block'
            },
            hideQuote() {
                let form = document.getElementById('quote_form')
                form.style.display = 'none'
            },
            showPurchase() {
                let form = document.getElementById('purchase_form')
                form.style.display = 'block'
            },
            hidePurchase() {
                let form = document.getElementById('purchase_form')
                form.style.display = 'none'
            },
            changeMargin(e) {
                let target = e.target
                let val = target.value
                if (target.selectedIndex >= 0) {
                    // Set the input value
                    this.q_margin = val
                    // Save to quote data
                    this.quoteData[this.part_index]['margin_input'] = val
                    // Calculate other quote fields
                    this.calcQuote(e)
                }
                // Reset select for next use
                target.selectedIndex = '-1'
            },
            changeLead(e) {
                let target = e.target
                let val = target.value
                if (target.selectedIndex >= 0) {
                    // Set the input value
                    this.q_lead_time = val
                    // Save to quote data
                    this.quoteData[this.part_index]['lead_time'] = val
                }
                // Reset select for next use
                target.selectedIndex = '-1'
            },
            changeChargeType(e) {
                let target = e.target
                let val = target.value
                if (target.selectedIndex >= 0) {
                    // Set the input value
                    this.q_extra_charge_type = val
                    // Save to quote data
                    this.quoteData[this.part_index]['extra_charge_type'] = val
                }
                // Reset select for next use
                target.selectedIndex = '-1'
            },
            changeUom(e) {
                let target = e.target
                let val = target.value
                if (target.selectedIndex >= 0) {
                    // Set the input value
                    this.q_unit_of_measure = val
                    // Save to quote data
                    this.quoteData[this.part_index]['unit_of_measure'] = val
                }
                // Reset select for next use
                target.selectedIndex = '-1'
            },
            change_pUom(e) {
                let target = e.target
                let val = target.value
                if (target.selectedIndex >= 0) {
                    // Set the input value
                    this.p_unit_of_measure = val
                    // Save to quote data
                    this.purchaseData[this.part_index]['unit_of_measure'] = val
                }
                // Reset select for next use
                target.selectedIndex = '-1'
            },
            calcQuote(e) {
                function calc_quote_ext_quote(this_vue) {
                    if ((this_vue.q_unit_cost > 0) & (this_vue.q_margin != null)) {
                        // qt = cst * mgn
                        // ext_qu = (sct * mgn) qty
                        this_vue.q_quote = Number.parseFloat(
                            this_vue.q_unit_cost / (1 - this_vue.q_margin / 100)
                        ).toFixed(2)
                        this_vue.quoteData[this_vue.part_index]['quote'] = this_vue.q_quote
                        if (this_vue.q_quantity > 0) {
                            this_vue.q_ext_quote = Number.parseFloat(
                                this_vue.q_quote * this_vue.q_quantity
                            ).toFixed(2)
                            this_vue.quoteData[this_vue.part_index]['ext_quote'] =
                                this_vue.q_ext_quote
                        }
                    }
                }
                function calc_quote_price(this_vue) {
                    if (this_vue.q_unit_cost > 0) {
                        this_vue.q_margin = Number.parseFloat(
                            (1 - this_vue.q_unit_cost / this_vue.q_quote) * 100
                        ).toFixed(2)
                        this_vue.quoteData[this_vue.part_index]['margin_input'] = this_vue.q_margin
                        this_vue.quoteData[this_vue.part_index]['margin'] = this_vue.q_margin
                        if (this_vue.q_quantity > 0) {
                            this_vue.q_ext_quote = Number.parseFloat(
                                this_vue.q_quote * this_vue.q_quantity
                            ).toFixed(2)
                            this_vue.quoteData[this_vue.part_index]['ext_quote'] =
                                this_vue.q_ext_quote
                        }
                    }
                }

                if (e == undefined) {
                    calc_quote_ext_quote(this)
                } else {
                    if (e == 'pricing_action') {
                        calc_quote_price(this)
                    } else if (e.target.id == 'q_quote') {
                        calc_quote_price(this)
                    } else {
                        calc_quote_ext_quote(this)
                    }
                }
            },
            dragFile(e) {
                this.upload_files = []
                let fnames = document.getElementById('upload_file_names')
                let modal = document.getElementById('modal_upload')
                let droppedFiles = e.dataTransfer.files
                if (!droppedFiles) return
                ;[...droppedFiles].forEach((f) => {
                    if (f.name.includes('.xls')) {
                        modal.classList.add('is-active')
                        let li = document.createElement('li')
                        li.innerText = f.name
                        fnames.appendChild(li)
                        this.upload_files.push(f)
                    } else {
                        alert('All files are expected to be Excel format.')
                    }
                })
            },
            cancelModal() {
                document.getElementById('modal_upload').classList.remove('is-active')
                this.upload_files = []
                let fnames = document.getElementById('upload_file_names')
                fnames.innerText = ''
            },
            ajaxUpload(url, search_type, search_customer) {
                // Aggregate the files for upload
                let formData = new FormData()
                formData.append('type', search_type)
                formData.append('customer', search_customer)
                this.upload_files.forEach((f, x) => {
                    formData.append('file' + (x + 1), f)
                })

                fetch(url, {
                    method: 'POST',
                    body: formData,
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            let parts_array = res.part_numbers
                            let part_objects = res.parsed_data
                            let search_action_id = res.search_action_id
                            this.start_modal_search(
                                parts_array,
                                part_objects,
                                search_action_id,
                                search_type,
                                search_customer
                            )
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            start_modal_search(
                parts_array,
                part_objects,
                search_action_id,
                search_type,
                search_customer
            ) {
                // Close modal and reset variables
                this.cancelModal()
                this.resetVars()
                // Set new variables and search
                this.search_action_id = search_action_id
                this.search_type = search_type
                this.search_customer = search_customer
                this.searchStore.set_parts_array(parts_array)
                this.searchStore.set_part_selected(parts_array[0])
                this.part_number = parts_array[0]
                let quantity_list = this.init_quote_data_upload(part_objects)

                let force_search = false
                this.search_stream(
                    parts_array,
                    quantity_list,
                    search_action_id,
                    search_type,
                    search_customer,
                    null,
                    this.is_nsn,
                    this.includeGSA,
                    force_search
                )
            },
            start_search() {
                let is_nsn = this.is_nsn
                let parts_text = this.parts_text
                let quantity_array = this.quantity_array
                let search_type = this.search_type
                let search_customer = this.search_customer
                let customer_ref = this.search_reference
                let search_action_id = this.search_action_id
                let parts_array = this.parsePN(parts_text)
                const re = new RegExp('^[0-9]+$')
                for (let qty of quantity_array) {
                    if (!qty.match(re)) {
                        alert(
                            'Check Quantities:\nOnly integer numbers are allowed (no special characters).'
                        )
                        return
                    }
                }
                if ((parts_array.length == quantity_array.length) | (quantity_array.length == 0)) {
                    this.searchStore.set_parts_array(parts_array)
                    this.searchStore.set_part_selected(parts_array[0]) //Object.assign({}, parts_array[0]);
                } else {
                    alert(
                        `Unequal lengths: Part/Quantity\n\nWe need same number of parts (${parts_array.length}) and quantities (${quantity_array.length}) before we can start the search. `
                    )
                    return
                }

                this.init_quote_data(this.parts_array, quantity_array)
                // this.ajax_get_db_parts()

                let force_search = false
                this.search_stream(
                    parts_text,
                    quantity_array,
                    search_action_id,
                    search_type,
                    search_customer,
                    customer_ref,
                    is_nsn,
                    this.includeGSA,
                    force_search
                )
            },
            init_purchase_data(parts_array) {
                for (let i = 0; i < parts_array.length; i++) {
                    this.purchaseData[i] = {
                        part_number: parts_array[i],
                        no_purchase: false,
                        submitted: false,
                    }
                }
            },
            init_quote_data(parts_array, quantity_array) {
                for (let i = 0; i < parts_array.length; i++) {
                    let quantity = null // quantities are not guaranteed
                    if (quantity_array.length == parts_array.length) {
                        quantity = quantity_array[i]
                    }
                    this.quoteData[i] = {
                        part_number: parts_array[i],
                        quantity: quantity,
                        quote_type: this.search_type,
                        customer: this.search_customer,
                        customer_ref: this.search_reference,
                        no_quote: false,
                        submitted: false,
                        no_quote_reason: '',
                    }
                }
            },
            edit_quote_data(customer, reference) {
                this.search_customer = customer
                this.search_reference = reference
                for (const idx in this.quoteData) {
                    this.quoteData[idx].customer = customer
                    this.quoteData[idx].customer_ref = reference
                }
            },
            init_quote_data_upload(part_objects) {
                // Take an array of part objects and initialze the quote data
                let quantity_list = []
                for (let i = 0; i < part_objects.length; i++) {
                    let part = part_objects[i].part_number
                    let quantity = part_objects[i].quantity
                    let description = part_objects[i].description
                    let lead_time = part_objects[i].lead_time
                    let unit_of_measure = part_objects[i].units
                    let id = part_objects[i].quote_id
                    this.quoteData[i] = {
                        id: id,
                        part_number: part,
                        description: description,
                        quantity: quantity,
                        lead_time: lead_time,
                        unit_of_measure: unit_of_measure,
                        quote_type: this.search_type,
                        customer: this.search_customer,
                        customer_ref: this.search_reference,
                        no_quote: false,
                        submitted: false,
                    }
                    quantity_list.push(quantity)
                }
                return quantity_list
            },
            end_search() {
                this.searching = false
                this.$toast.open({ message: 'Search complete', type: 'default' })
            },
            resetVars() {
                // Set store variables
                this.searchStore.set_parts_array([])
                this.searchStore.set_part_selected('')
                this.searchStore.set_part_index(0)

                // Set local vars
                this.new_search = false
                this.is_nsn = false
                this.duplicate_part_index = -1
                this.duplicate_reference = []
                this.search_action_id = 0
                this.search_type = ''
                this.search_customer = ''
                this.search_reference = ''
                this.alertData = []
                this.bannerData = []
                this.searchDataRaw = []
                this.dbPartDataRaw = []
                this.dbCapPartDataRaw = []
                // this.searchData = []
                this.statsData = []
                this.parts_text = ''
                this.quantities_text = ''
                this.sales_lastyr = 0
                this.sales_currentyr = 0
                this.sales_tot_qty = 0
                this.quotes_lastyr = 0
                this.quotes_currentyr = 0
                this.quotes_tot_qty = 0
                this.total_sales = 0
                this.total_quotes = 0
                this.avg_cost = 0
                this.avg_price = 0
                this.avg_quote = 0
                this.win_percent = 0
                this.avg_margin = 0
                this.last_quote = 0
                this.stream_data = ''
                this.pn_count = ''
                this.upload_files = []
                this.quoteData = []
                this.research_purchases_only = false
                this.generic_research_only = false
                this.purchaseData = []
                this.pricing_rule_match = []
                this.modal_rule = {}
                this.partsbase_pricing = []
                this.partsbase_market = []
                this.all_fuzzy_part_matches = {}
                this.all_google_search = {}
                this.google_search_key = 0
                // quote values
                this.q_part_number = ''
                this.q_description = ''
                this.q_quantity = ''
                this.q_vendor = ''
                this.q_unit_cost = ''
                this.q_margin = ''
                this.q_quote = ''
                this.q_list_price = ''
                this.q_ext_quote = ''
                this.q_notes = ''
                this.q_unit_of_measure = ''
                this.q_exchange = false
                this.q_core = ''
                this.q_extra_charge_type = ''
                this.q_extra_charge = ''
                this.q_no_quote_reason = ''
                // purchase values
                this.p_part_number = ''
                this.p_description = ''
                this.p_quantity = ''
                this.p_unit_of_measure = ''
                this.p_unit_cost = ''
                this.p_margin = ''
                this.p_notes = ''
                //notes
                this.sales_notes = []
                this.admin_notes = []
                // Pricing action data for modal
                this.pa_suggested_price = 0
                this.pa_suggested_margin = 0
                this.pa_description = ''
                this.pa_reason = ''
                this.pa_id = 0
                this.bpa_parts = []
            },
            ajax_add_user_note: function (new_note) {
                let url = USER_NOTE_CREATE
                let part = this.part_selected
                let sales_notes = this.sales_notes
                function append_note(note) {
                    sales_notes.push(note)
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ note: new_note, part: part }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            // Return a note object containing note/user/timestamp
                            append_note(res)
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            ajax_add_admin_note: function (new_note) {
                let url = ADMIN_NOTE_CREATE
                let part = this.part_selected
                let admin_notes = this.admin_notes
                function append_note(note) {
                    admin_notes.push(note)
                }
                fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ note: new_note, part: part }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            // Return a note object containing note/user/timestamp
                            append_note(res)
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            ajax_edit_quote_part: async function (quote_part_edits) {
                // quote_part_edits is array of dicts [{quote_id, part_number}, {}, ...]
                let url = QUOTE_EDIT_PART
                await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({ quote_part_edits: quote_part_edits }),
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            // Return a note object containing note/user/timestamp
                        } else {
                            alert('Error: Upload error')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            ajax_edit_search_action_parts: async function (
                search_action_id,
                part_number_list,
                new_parts_list,
                changed_parts_dict
            ) {
                // Given a search_action_id, replace current parts with part_number_list
                try {
                    const res = await this.searchStore.updateSearchActionParts({
                        search_action_id,
                        part_number_list,
                        new_parts_list,
                        changed_parts_dict,
                    })
                    const ok =
                        res?.search_action_id !== undefined &&
                        res?.search_action_id !== null &&
                        Array.isArray(res?.part_number_list)
                    if (!ok) {
                        alert('Error: Upload error')
                    }
                } catch (e) {
                    console.error(JSON.stringify(e.message))
                }
            },
            ajax_edit_searchaction_customer_reference(customer, reference) {
                let search_action_id = this.search_action_id
                let edit_quote_data = this.edit_quote_data
                function change_values(customer, reference) {
                    edit_quote_data(customer, reference)
                    this.$toast.open({ message: 'Values saved', type: 'success' })
                }
                this.searchStore
                    .updateSearchActionCustomerReference({
                        id: search_action_id,
                        customer,
                        customer_ref: reference,
                    })
                    .then((res) => {
                        const ok =
                            res?.id !== undefined &&
                            res?.id !== null &&
                            res?.customer_ref !== undefined
                        if (ok) {
                            change_values(customer, reference)
                        } else {
                            alert('Error: Values not changed')
                        }
                    })
                    .catch((e) => {
                        console.error(JSON.stringify(e.message))
                    })
            },
            ajax_stream_quote_from_db(search_action_id) {
                // Given a search_action_id, retrieve all saved data from database
                // and display for user to edit
                this.searching = true
                async function process(writeMethod, search_action_id) {
                    // Retrieve NDJSON from the server
                    const response = await fetch(STREAM_QUOTE, {
                        method: 'POST',
                        body: JSON.stringify({ search_action_id: search_action_id }),
                    })

                    const results = response.body
                    // From bytes to text:
                    // .pipeThrough(new TextDecoder())

                    // Loop through the results and write to the DOM
                    writeMethod(results.getReader())
                }
                process(this.writeToDOM, search_action_id)
            },
            ajax_research_parts(parts_list) {
                // Given a search_action_id, retrieve all saved data from database
                // and display for user to edit
                this.searching = true
                async function process(writeMethod, parts_list) {
                    // Retrieve NDJSON from the server
                    const response = await fetch(STREAM_RESEARCH, {
                        method: 'POST',
                        body: JSON.stringify({ parts_list: parts_list }),
                    })

                    const results = response.body
                    // From bytes to text:
                    // .pipeThrough(new TextDecoder())

                    // Loop through the results and write to the DOM
                    writeMethod(results.getReader())
                }
                process(this.writeToDOM, parts_list)
            },
            search_stream(
                parts_text,
                quantity_array,
                search_action_id,
                search_type,
                search_customer,
                customer_ref,
                is_nsn,
                force_search = false
            ) {
                /*
        The main search action that sequentially searches streams results from the server.
        This will only be called for NEW searches, not for viewing existing quotes.
      */
                this.new_search = true
                async function process(writeMethod, json_post) {
                    // Retrieve NDJSON from the server
                    const response = await fetch(STREAM_PART, {
                        method: 'POST',
                        body: JSON.stringify(json_post),
                    })

                    const results = response.body
                    // From bytes to text:
                    // .pipeThrough(new TextDecoder())

                    // Loop through the results and write to the DOM
                    writeMethod(results.getReader())
                }
                this.searching = true
                let json_post = {
                    part_number: parts_text,
                    quantity_list: quantity_array,
                    customer: search_customer,
                    quote_type: search_type,
                    customer_ref: customer_ref,
                    is_nsn: is_nsn,
                    force_search: force_search,
                }
                if (this.search_action_id > 0) {
                    // If we have a search action, pass it back to avoid creating a new one and overwriting current quoteData
                    json_post['search_action_id'] = this.search_action_id
                } else if (search_action_id != null) {
                    // Search action from RFQ file upload
                    json_post['search_action_id'] = search_action_id
                }
                process(this.writeToDOM, json_post)
            },
            writeToDOM(reader) {
                reader.read().then(
                    ({ value, done }) => {
                        if (done) {
                            this.end_search()
                        } else {
                            let d = new TextDecoder()
                            let val = d.decode(value)
                            if (val.endsWith('{{ENDREC}}')) {
                                // Append to response buffer then move to finished buffer
                                // to avoid race conditions
                                let finished_buffer = this.response_buffer + val
                                // Clear buffer
                                this.response_buffer = ''

                                // // Concat results from buffer to searchDataRaw object
                                let split = finished_buffer.split('{{ENDREC}}')
                                for (let s in split) {
                                    // Each record can now be edited before display
                                    let record = split[s]
                                    // Remove blanks
                                    if (record == '') {
                                        continue
                                    }
                                    let parsed = JSON.parse(record)
                                    if (
                                        Object.prototype.hasOwnProperty.call(
                                            parsed,
                                            'duplicate_reference'
                                        )
                                    ) {
                                        // Alert user that someone is working on a quote with the same reference number
                                        this.duplicate_reference = parsed.duplicate_reference
                                        // Show alert dialog
                                    } else if (
                                        Object.prototype.hasOwnProperty.call(parsed, 'pulse')
                                    ) {
                                        // Updates on the status of the result stream
                                        let pulse = parsed.pulse
                                        if (Object.prototype.hasOwnProperty.call(pulse, 'error')) {
                                            alert(
                                                'Something went wrong while streaming:\n\n' +
                                                    pulse.error
                                            )
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(pulse, 'pn_count')
                                        ) {
                                            this.pn_count = pulse.pn_count
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(pulse, 'pn_total')
                                        ) {
                                            this.pn_total = pulse.pn_total
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(pulse, 'process')
                                        ) {
                                            this.process = pulse.process
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(pulse, 'sub_count')
                                        ) {
                                            this.sub_count = pulse.sub_count
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(pulse, 'sub_total')
                                        ) {
                                            this.sub_total = pulse.sub_total
                                        }
                                    } else if (
                                        Object.prototype.hasOwnProperty.call(
                                            parsed,
                                            'search_action_id'
                                        )
                                    ) {
                                        // Keep track of the search action id in order
                                        // to append to all future actions
                                        let search_action_id = parsed.search_action_id
                                        this.search_action_id = search_action_id
                                        // Retrieve the quote data from stream parts
                                        // or saved quote
                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                parsed,
                                                'quote_items'
                                            )
                                        ) {
                                            // Load existing quote from MyQuotes
                                            let quote_items = parsed.quote_items
                                            this.quoteData = quote_items
                                            // Load data into q_ quote variables
                                            this.partChange()
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                parsed,
                                                'search_action'
                                            )
                                        ) {
                                            let sa = parsed.search_action
                                            this.set_search_props(sa)
                                        }
                                        if (!this.$route.path.includes('/Search/')) {
                                            history.pushState(
                                                {},
                                                null,
                                                `${this.$route.path}#/Search/${this.search_action_id}`
                                            )
                                        }
                                        //   this.admin_auth = parsed.admin_auth
                                    } else if (
                                        Object.prototype.hasOwnProperty.call(parsed, 'note_type')
                                    ) {
                                        // Separate the notes into sales and admin
                                        if (parsed.note_type == 'sales') {
                                            this.sales_notes.push(parsed)
                                        } else if (parsed.note_type == 'admin') {
                                            this.admin_notes.push(parsed)
                                        }
                                    } else {
                                        if (parsed[0] == false) {
                                            continue
                                        } else if (parsed[0].site == 'db_parts') {
                                            this.dbPartDataRaw = parsed[0].data
                                        } else if (parsed[0].site == 'db_cap_parts') {
                                            this.dbCapPartDataRaw = parsed[0].data
                                        } else if (parsed[0].site == 'bpa_parts') {
                                            let new_parts = parsed[0].data.bpa_parts
                                            let bpa_parts = this.bpa_parts
                                            for (let p of new_parts) {
                                                const part = typeof p === 'object' ? p.part || p.part_number : p
                                                if (part && !bpa_parts.includes(part)) {
                                                    bpa_parts.push(part)
                                                    this.bannerData.push({
                                                        customer: '',
                                                        part_number: part,
                                                        text: 'BPA-PART: Must no-quote because this part is covered under a bulk purchase agreement.',
                                                    })
                                                }
                                            }
                                        } else if (parsed[0].site == 'banner_alerts') {
                                            // There could be multiple sources for banner alerts, so concatenate
                                            this.bannerData = this.bannerData.concat(parsed[0].data)
                                            // DON'T create a table
                                            continue
                                        } else if (parsed[0].site == 'pricing_rule_match') {
                                            // Data contains single part number so extend array
                                            for (let pr of parsed) {
                                                this.pricing_rule_match =
                                                    this.pricing_rule_match.concat(pr.data)
                                            }
                                            // DON'T create a table
                                            continue
                                        } else if (parsed[0].site == 'partsbase_pricing') {
                                            // Data contains single part number so extend array
                                            for (let pr of parsed) {
                                                this.partsbase_pricing =
                                                    this.partsbase_pricing.concat(pr)
                                            }
                                            // DON'T create a table
                                            continue
                                        } else if (parsed[0].site == 'partsbase_market') {
                                            // Data contains single part number so extend array
                                            for (let pr of parsed) {
                                                this.partsbase_market =
                                                    this.partsbase_market.concat(pr)
                                            }
                                            // DON'T create a table
                                            continue
                                        } else if (parsed[0].site == 'fuzzy_part_matches') {
                                            // Data contains single part number so extend array
                                            this.all_fuzzy_part_matches = parsed[0].data
                                            // DON'T create a table
                                            continue
                                        } else if (
                                            (parsed[0].site == 'Google Search') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'title'
                                                )
                                            ) {
                                                // format google search data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    // parsed[0].data[i].price = numeral(parsed[0].data[i].unit_cost).format('$0,0,0,0,0.00')
                                                    let link = parsed[0].data[i].link
                                                    if (link) {
                                                        if (link.includes('//')) {
                                                            let s1 = link.split('//')[1]
                                                            if (link.includes('/')) {
                                                                let link_site = s1.split('/')[0]
                                                                let link_html = `<a href="${link}" target="_blank">${link_site}</a>`
                                                                parsed[0].data[i].link = link_html
                                                            }
                                                        }
                                                        if (link.startsWith('/')) {
                                                            let link_html = `<a href="https://google.com${link}" target="_blank">google.com</a>`
                                                            parsed[0].data[i].link = link_html
                                                        }
                                                    }
                                                    let image = parsed[0].data[i].image
                                                    if (image) {
                                                        let image_html = `<img src="${image}" style="max-height:100px">`
                                                        parsed[0].data[i].image = image_html
                                                    }
                                                }
                                            }
                                            this.all_google_search[parsed[0].part] = parsed[0].data
                                            this.google_search_key += 1
                                            // DON'T create a table
                                            continue
                                        } else if (
                                            (parsed[0].site == 'Sales') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format sales data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].unit_cost = numeral(
                                                        parsed[0].data[i].unit_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].total_cost = numeral(
                                                        parsed[0].data[i].total_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].unit_price = numeral(
                                                        parsed[0].data[i].unit_price
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].total_price = numeral(
                                                        parsed[0].data[i].total_price
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].profit = numeral(
                                                        parsed[0].data[i].profit
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].margin = numeral(
                                                        parsed[0].data[i].margin
                                                    ).format('0.00%')
                                                    parsed[0].data[i].post_date = moment(
                                                        parsed[0].data[i].post_date
                                                    ).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Quotes') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].unit_cost = numeral(
                                                        parsed[0].data[i].unit_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].quote = numeral(
                                                        parsed[0].data[i].quote
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].ext_quote = numeral(
                                                        parsed[0].data[i].ext_quote
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].margin = numeral(
                                                        parsed[0].data[i].margin / 100
                                                    ).format('0.0%')
                                                    parsed[0].data[i].time_created = moment(
                                                        parsed[0].data[i].time_created
                                                    ).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Repair Orders') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].ro_parts_cost = numeral(
                                                        parsed[0].data[i].ro_parts_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].ro_misc_cost = numeral(
                                                        parsed[0].data[i].ro_misc_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].ro_total_cost = numeral(
                                                        parsed[0].data[i].ro_total_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].so_unit_price = numeral(
                                                        parsed[0].data[i].so_unit_price
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].margin = numeral(
                                                        parsed[0].data[i].margin / 100
                                                    ).format('0.0%')
                                                    parsed[0].data[i].last_updated = moment(
                                                        parsed[0].data[i].last_updated
                                                    ).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Inventory ComponentControl') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            // This is the old site name, but same info as "Greenwood Ponca Inventory"
                                            // Keep this for backward compatibility with old searches
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].unit_cost = numeral(
                                                        parsed[0].data[i].unit_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    // parsed[0].data[i].time_created = moment(parsed[0].data[i].time_created).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Greenwood Ponca Inventory') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    let warehouse = parsed[0].data[i].warehouse
                                                    if (
                                                        [
                                                            'JLS-BPA',
                                                            'GWG-OKJ',
                                                            'GWG-KPNC',
                                                            'USG-T6',
                                                        ].includes(warehouse) |
                                                        warehouse.endsWith('-MP')
                                                    ) {
                                                        // These are formatted as text "NEED APPROVAL"
                                                    } else {
                                                        parsed[0].data[i].unit_cost = numeral(
                                                            parsed[0].data[i].unit_cost
                                                        ).format('$0,0,0,0,0.00')
                                                    }

                                                    // parsed[0].data[i].time_created = moment(parsed[0].data[i].time_created).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Open Sales Orders') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].est_cost = numeral(
                                                        parsed[0].data[i].est_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].unit_price = numeral(
                                                        parsed[0].data[i].unit_price
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].total_price = numeral(
                                                        parsed[0].data[i].total_price
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].total_cost = numeral(
                                                        parsed[0].data[i].total_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].profit = numeral(
                                                        parsed[0].data[i].profit
                                                    ).format('$0,0,0,0,0.00')
                                                    // parsed[0].data[i].time_created = moment(parsed[0].data[i].time_created).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Open Purchase Orders') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format quote data
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    parsed[0].data[i].unit_cost = numeral(
                                                        parsed[0].data[i].unit_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    parsed[0].data[i].total_cost = numeral(
                                                        parsed[0].data[i].total_cost
                                                    ).format('$0,0,0,0,0.00')
                                                    // parsed[0].data[i].time_created = moment(parsed[0].data[i].time_created).format('YYYY-MM-DD')
                                                }
                                            }
                                        } else if (
                                            (parsed[0].site == 'Boeing/Aviall') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'part_number'
                                                )
                                            ) {
                                                // format Boeing/Aviall data and remove unwanted rows
                                                let formatted_data = []
                                                let keep_cols = [
                                                    'part_number',
                                                    'name',
                                                    'description',
                                                    'quantity',
                                                    'netPrice',
                                                    'locationAvailabilities',
                                                    'errors',
                                                ]
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    let row = parsed[0].data[i]
                                                    let d = {}
                                                    if (
                                                        Object.prototype.hasOwnProperty.call(
                                                            row,
                                                            'errors'
                                                        )
                                                    ) {
                                                        let errors = row.errors
                                                        if (errors.length > 0) {
                                                            let error = errors[0]
                                                            if (
                                                                Object.prototype.hasOwnProperty.call(
                                                                    error,
                                                                    'errorCode'
                                                                )
                                                            ) {
                                                                if (
                                                                    error.errorCode == 'ZOTC_MC047'
                                                                ) {
                                                                    continue // Skip blank rows
                                                                }
                                                            }
                                                        }
                                                    }
                                                    for (let col of keep_cols) {
                                                        if (
                                                            Object.prototype.hasOwnProperty.call(
                                                                row,
                                                                col
                                                            )
                                                        ) {
                                                            if (col == 'netPrice') {
                                                                d[col] = numeral(row[col]).format(
                                                                    '$0,0,0,0,0.00'
                                                                )
                                                            } else if (
                                                                col == 'locationAvailabilities'
                                                            ) {
                                                                let avail = ''
                                                                for (let avl of row[col]) {
                                                                    avail += `${avl.location}:  ${avl.availQuantity}\n`
                                                                }
                                                                d[col] = avail
                                                            } else {
                                                                d[col] = row[col]
                                                            }
                                                        }
                                                    }
                                                    formatted_data.push(d)
                                                }
                                                parsed[0].data = formatted_data
                                            }
                                        } else if (
                                            (parsed[0].site == 'Textron') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'PartNumber'
                                                )
                                            ) {
                                                // format Textron data and remove unwanted rows
                                                let parts_added = []
                                                let formatted_data = []
                                                let keep_cols_textron = [
                                                    'PartNumber',
                                                    'Desc',
                                                    'stock_wichita',
                                                    'stock_other',
                                                    'stock',
                                                    'stock_service',
                                                    'list_price',
                                                    'your_price',
                                                    'discount',
                                                    'isProprietary',
                                                    'Locations',
                                                    'ServiceCenters',
                                                    'SubstituteParts',
                                                    'Notes',
                                                    'MinOrder',
                                                    'UnitOfMeasure',
                                                    'CoreDeposit',
                                                    'HazardousMat',
                                                    'ShelfLife',
                                                    'ShelfLifeTerm',
                                                    'ShelfLifeDays',
                                                    'HasMandatorySub',
                                                    'IsReturnable',
                                                    'errors',
                                                ]
                                                // let price_cols = ['netPrice']
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    let row = parsed[0].data[i]
                                                    let d = {}
                                                    if (
                                                        Object.prototype.hasOwnProperty.call(
                                                            row,
                                                            'PartNumber'
                                                        )
                                                    ) {
                                                        if (
                                                            row.PartNumber ==
                                                            'Part Number not Found'
                                                        ) {
                                                            continue // Remove blank rows
                                                        }
                                                        if (parts_added.includes(row.PartNumber)) {
                                                            continue // Only show a part once
                                                        }
                                                        parts_added.push(row.PartNumber)
                                                    }
                                                    for (let col of keep_cols_textron) {
                                                        if (
                                                            Object.prototype.hasOwnProperty.call(
                                                                row,
                                                                col
                                                            )
                                                        ) {
                                                            if (
                                                                [
                                                                    'list_price',
                                                                    'your_price',
                                                                    'CoreDeposit',
                                                                ].includes(col)
                                                            ) {
                                                                d[col] = numeral(row[col]).format(
                                                                    '$0,0,0,0,0.00'
                                                                )
                                                            } else if (col == 'discount') {
                                                                d[col] = row[col] + '%'
                                                            } else if (
                                                                [
                                                                    'Locations',
                                                                    'ServiceCenters',
                                                                ].includes(col)
                                                            ) {
                                                                let location = ''
                                                                if (row[col] !== null) {
                                                                    // Check for null column
                                                                    for (let l of row[col]) {
                                                                        let loc = ''
                                                                        let qty = ''
                                                                        if (
                                                                            Object.prototype.hasOwnProperty.call(
                                                                                l,
                                                                                'Location'
                                                                            )
                                                                        ) {
                                                                            loc = l.Location
                                                                        }
                                                                        if (
                                                                            Object.prototype.hasOwnProperty.call(
                                                                                l,
                                                                                'QuantityAvail'
                                                                            )
                                                                        ) {
                                                                            qty = l.QuantityAvail
                                                                        }
                                                                        location += `${loc}:  ${qty}\n`
                                                                        if (
                                                                            Object.prototype.hasOwnProperty.call(
                                                                                l,
                                                                                'PotentialAvailableDate'
                                                                            )
                                                                        ) {
                                                                            if (
                                                                                l.PotentialAvailableDate
                                                                            ) {
                                                                                location += `Estimated: ${l.PotentialAvailableDate}\n`
                                                                            }
                                                                        }
                                                                    }
                                                                    d[col] = location
                                                                }
                                                            } else if (col == 'SubstituteParts') {
                                                                let psubs = ''
                                                                if (row[col] !== null) {
                                                                    for (let l of row[col]) {
                                                                        if (
                                                                            Object.prototype.hasOwnProperty.call(
                                                                                l,
                                                                                'PartNumber'
                                                                            )
                                                                        ) {
                                                                            psubs += `${l.PartNumber}\n`
                                                                        }
                                                                    }
                                                                }
                                                                d[col] = psubs
                                                            } else if (
                                                                [
                                                                    'HazardousMat',
                                                                    'ShelfLife',
                                                                    'ShelfLifeTerm',
                                                                ].includes(col)
                                                            ) {
                                                                // Remove these columns
                                                            } else {
                                                                d[col] = row[col]
                                                            }
                                                        }
                                                    }
                                                    formatted_data.push(d)
                                                }
                                                parsed[0].data = formatted_data
                                            }
                                        } else if (
                                            (parsed[0].site == 'Textron Defense') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            if (
                                                Object.prototype.hasOwnProperty.call(
                                                    parsed[0].data[0],
                                                    'PartNumber'
                                                )
                                            ) {
                                                // format Textron data and remove unwanted rows
                                                let parts_added = []
                                                let formatted_data = []
                                                for (let i = 0; i < parsed[0].data.length; i++) {
                                                    let row = parsed[0].data[i]
                                                    let d = {}
                                                    if (
                                                        Object.prototype.hasOwnProperty.call(
                                                            row,
                                                            'part_num'
                                                        )
                                                    ) {
                                                        if (parts_added.includes(row.part_num)) {
                                                            continue // Only show a part once
                                                        }
                                                        parts_added.push(row.part_num)
                                                    }
                                                    formatted_data.push(d)
                                                }
                                                parsed[0].data = formatted_data
                                            }
                                        } else if (
                                            (parsed[0].site == 'ILS') &
                                            (parsed[0].data.length > 0)
                                        ) {
                                            // Remove bad ILS companies
                                            let rem_comp = [
                                                'RAP LLC (Ross Aviation Parts) (CDKX)',
                                                'Banyan Air Service (7253)',
                                                'Seattle Aviation Solutions (C9FN)',
                                                'RAP LLC (Ross Aviation Parts)',
                                                'Banyan Air Service',
                                                'Seattle Aviation Solutions',
                                            ]
                                            // ILS returns multiple records at once, so clean all of them (not just [0])
                                            for (let p in parsed) {
                                                for (
                                                    let i = parsed[p].data.length - 1;
                                                    i >= 0;
                                                    i--
                                                ) {
                                                    // Start from the end of the array and remove objects if needed
                                                    let row = parsed[p].data[i]
                                                    if (
                                                        Object.prototype.hasOwnProperty.call(
                                                            row,
                                                            'company'
                                                        )
                                                    ) {
                                                        if (rem_comp.indexOf(row.company) >= 0) {
                                                            parsed[p].data.splice(i, 1)
                                                        }
                                                    }
                                                }
                                                for (
                                                    let i = parsed[p].data.length - 1;
                                                    i >= 0;
                                                    i--
                                                ) {
                                                    // Start from the end of the array and remove objects if needed
                                                    let row = parsed[p].data[i]
                                                    // Remove if Quantity = "RQST"
                                                    if (
                                                        Object.prototype.hasOwnProperty.call(
                                                            row,
                                                            'quantity'
                                                        )
                                                    ) {
                                                        if (row.quantity == 'RQST') {
                                                            parsed[p].data.splice(i, 1)
                                                        }
                                                    }
                                                }
                                            }
                                        } else if (parsed[0].site == 'Textron Spread') {
                                            // Save data for alert
                                            for (let spread of parsed) {
                                                if (spread.alert == 'True') {
                                                    this.alertData.push(spread.data[0])
                                                }
                                            }
                                        }
                                        // Everything else is search data
                                        // Add this record to the search data
                                        this.searchDataRaw = this.searchDataRaw.concat(parsed)
                                    }
                                }
                            } else {
                                this.response_buffer = this.response_buffer + val
                            }
                            // Recursively call
                            this.writeToDOM(reader)
                        }
                    },
                    (e) => console.error('The stream became errored and cannot be read from!', e)
                )
            },
            updateInfo(info) {
                this.stream_data = this.stream_data + info
            },
            resetStats() {
                this.total_sales = 0
                this.total_quotes = 0
                this.avg_cost = 0
                this.avg_price = 0
                this.avg_quote = 0
                this.win_percent = 0
                this.avg_margin = 0
                this.last_quote = 0
            },
            previousPart() {
                let new_idx = this.part_index - 1
                if (new_idx >= 0) {
                    this.searchStore.set_part_index(new_idx)
                }
            },
            nextPart() {
                let new_idx = this.part_index + 1
                if (new_idx < this.parts_array.length) {
                    this.searchStore.set_part_index(new_idx)
                }
            },
            calcStats() {
                //Calculate summary stats when part is changed or new data arrives
                this.resetStats()
                // Create dataframes
                let df_sales = new DataFrame([], [])
                let df_quotes = new DataFrame([], [])
                for (let data of this.searchData) {
                    var do_stat = false
                    if (data.part == this.part_selected) {
                        // Use data if parts match
                        do_stat = true
                    }
                    if (this.is_research_purchase | this.is_generic_research) {
                        // Use data if research subs match
                        if (
                            Object.prototype.hasOwnProperty.call(this.research_subs_dict, data.part)
                        ) {
                            if (this.research_subs_dict[data.part] == this.part_selected) {
                                do_stat = true
                            }
                        }
                    }
                    // Add the data if any of the above conditions are true
                    if (do_stat) {
                        if (data.site == 'Sales') {
                            let sales = JSON.parse(JSON.stringify(data))
                            if (sales.data.length > 0) {
                                if (Object.keys(sales.data[0]).length > 1) {
                                    df_sales = new DataFrame(sales.data)
                                }
                            }
                        }
                        if (data.site == 'Quotes') {
                            let quotes = JSON.parse(JSON.stringify(data))
                            if (quotes.data.length > 0) {
                                if (Object.keys(quotes.data[0]).length > 1) {
                                    df_quotes = new DataFrame(quotes.data)
                                }
                            }
                        }
                    }
                }

                let part = this.part_selected
                let sale_stats = {
                    part: part,
                    site: 'Sale Stats',
                    href: '#',
                    found: true,
                    errors: [],
                    data: [],
                }
                let quote_stats = {
                    part: part,
                    site: 'Quote Stats',
                    href: '#',
                    found: true,
                    errors: [],
                    data: [],
                }
                let margin = {
                    part: part,
                    site: 'Margin',
                    href: '#',
                    found: true,
                    errors: [],
                    data: [],
                }

                function calc_stats(part, df_sales, df_quotes, current_year, last_year) {
                    // Columns are listed in order of insert, so add part first
                    let s_data = { 'Part Number': part }
                    let q_data = { 'Part Number': part }
                    let margin_data = { 'Part Number': part }

                    let total_sales = df_sales.count()
                    let total_quotes = df_quotes.count()
                    let win_percent = 0

                    if (total_quotes > 0) {
                        // QUOTES
                        q_data['Last Quote'] = df_quotes
                            .toDict()
                            .time_created.sort()
                            .reverse()[0]
                            .split('T')[0]
                        q_data[current_year.toString()] = df_quotes
                            .filter((row) => row.get('time_created') > current_year)
                            .count()
                        q_data[last_year.toString()] = df_quotes
                            .filter((row) => row.get('time_created') > last_year)
                            .filter((row) => row.get('time_created') < current_year)
                            .count()
                        q_data['Tot'] = total_quotes
                        q_data['Tot Qty'] = df_quotes.stat.sum('quantity')
                        //MARGIN
                        margin_data['Avg Quote'] = numeral(df_quotes.stat.mean('quote')).format(
                            '$0,0,0,0,0.00'
                        )
                        win_percent = (100 * (total_sales / total_quotes)).toFixed(1) + '%'
                    }

                    if (total_sales > 0) {
                        // SALES
                        s_data['Last Sale'] = df_sales
                            .toDict()
                            .post_date.sort()
                            .reverse()[0]
                            .split('T')[0]
                        s_data[current_year.toString()] = df_sales
                            .filter((row) => row.get('post_date') > current_year)
                            .count()
                        s_data[last_year.toString()] = df_sales
                            .filter((row) => row.get('post_date') > last_year)
                            .filter((row) => row.get('post_date') < current_year)
                            .count()
                        s_data['Tot'] = total_sales
                        s_data['Tot Qty'] = df_sales.stat.sum('qty_invoiced')
                        //MARGIN
                        let sum_price = df_sales.stat.sum('unit_price')
                        let sum_cost = df_sales.stat.sum('unit_cost')
                        let profit = sum_price - sum_cost
                        let margin = profit / sum_price
                        let avg_margin = numeral(margin).format('0.0%') // margin.toPrecision(4).toString() + '%'
                        margin_data['AVG Price'] = numeral(df_sales.stat.mean('unit_price')).format(
                            '$0,0,0,0,0.00'
                        )
                        margin_data['Avg Cost'] = numeral(df_sales.stat.mean('unit_cost')).format(
                            '$0,0,0,0,0.00'
                        )
                        margin_data['Avg Margin'] = avg_margin
                        margin_data['Won'] = win_percent
                    }
                    // No data if only part_number is listed in keys
                    if (Object.keys(s_data).length == 1) {
                        s_data = { Data: 'None' }
                    }
                    if (Object.keys(q_data).length == 1) {
                        q_data = { Data: 'None' }
                    }
                    if (Object.keys(margin_data).length == 1) {
                        margin_data = { Data: 'None' }
                    }

                    return { sales: s_data, quotes: q_data, margin: margin_data }
                }
                // Aggregate data
                function aggregate_data(stats) {
                    sale_stats.data.push(stats.sales)
                    quote_stats.data.push(stats.quotes)
                    margin.data.push(stats.margin)
                }

                let sale_parts = []
                let quote_parts = []
                if ((df_sales.count() > 0) & (df_sales.listColumns().length > 1)) {
                    // Convert columns to numbers
                    df_sales = df_sales.cast('unit_price', (val) => numeral(val).value())
                    df_sales = df_sales.cast('unit_cost', (val) => numeral(val).value())
                    //  Get unique part numbers
                    sale_parts = df_sales.unique('part_number').toArray().flat().reverse() //[0]
                }

                if ((df_quotes.count() > 0) & (df_quotes.listColumns().length > 1)) {
                    // Convert columns to numbers
                    df_quotes = df_quotes.cast('quote', (val) => numeral(val).value())
                    //  Get unique part numbers
                    quote_parts = df_quotes.unique('part_number').toArray().flat().reverse() //[0]
                }

                // Get unique part numbers from both dataframes
                let all_parts = sale_parts.concat(quote_parts)
                let all_unique_parts = [...new Set(all_parts)]

                // Do calculations
                for (let pn of all_unique_parts) {
                    let df_sales_filter = new DataFrame([], [])
                    let df_quotes_filter = new DataFrame([], [])
                    if (df_sales.listColumns().includes('part_number')) {
                        df_sales_filter = df_sales.filter((row) => row.get('part_number') == pn)
                    }
                    if (df_quotes.listColumns().includes('part_number')) {
                        df_quotes_filter = df_quotes.filter((row) => row.get('part_number') == pn)
                    }
                    let stats = calc_stats(
                        pn,
                        df_sales_filter,
                        df_quotes_filter,
                        this.current_year,
                        this.last_year
                    )
                    aggregate_data(stats)
                }
                if (all_unique_parts.length > 1) {
                    let all_stats = calc_stats(
                        'ALL PARTS',
                        df_sales,
                        df_quotes,
                        this.current_year,
                        this.last_year
                    )
                    aggregate_data(all_stats)
                }

                this.statsData = [quote_stats, sale_stats, margin]
            },
            partChange() {
                // Set the selected part in case we changed the part via dropdown
                this.searchStore.set_part_selected(this.parts_array[this.part_index])
                // reset quote properties
                this.q_part_number = ''
                this.q_part_quoted = ''
                this.q_description = ''
                this.q_quantity = ''
                this.q_vendor = ''
                this.q_list_price = ''
                this.q_unit_cost = ''
                this.q_margin = ''
                this.q_quote = ''
                this.q_ext_quote = ''
                this.q_notes = ''
                this.q_lead_time = ''
                this.q_unit_of_measure = ''
                this.q_exchange = false
                this.q_core = ''
                this.q_extra_charge_type = ''
                this.q_extra_charge = ''
                this.q_no_quote_reason = ''
                // update quote from from quoteData (if any)
                for (const prop in this.quoteData[this.part_index]) {
                    this['q_' + prop] = this.quoteData[this.part_index][prop]
                }

                // reset purchase properties
                // purchase properties
                this.p_part_number = ''
                this.p_description = ''
                this.p_quantity = ''
                this.p_vendor = ''
                this.p_unit_cost = ''
                this.p_notes = ''
                this.p_unit_of_measure = ''
                // update purchase from from purchaseData (if any)
                for (const prop in this.purchaseData[this.part_index]) {
                    this['p_' + prop] = this.purchaseData[this.part_index][prop]
                }

                // Check if part number is duplicate and has been submitted
                for (const idx in this.quoteData) {
                    if (idx >= this.part_index) {
                        this.duplicate_part_index = -1
                        break
                    }
                    let submitted = this.quoteData[idx]['submitted']
                    let part = this.quoteData[idx]['part_number']
                    if (submitted & (part == this.q_part_number)) {
                        this.duplicate_part_index = idx
                        break
                    }
                }

                // Pricing action data for modal
                this.pa_suggested_price = 0
                this.pa_suggested_margin = 0
                this.pa_description = ''
                this.pa_reason = ''
                this.pa_id = 0

                // Calculate summary statistics
                this.calcStats()
            },
            parsePN(parts_text) {
                // Split part numbers text into array
                // Break on return or tab, upper case, only single space allowed in part number
                let parts_array = parts_text
                    .toUpperCase()
                    .replace(/[ \t]+/, ' ')
                    .split(/\n/)
                for (let i = parts_array.length - 1; i >= 0; i--) {
                    // Strip whitespace
                    parts_array[i] = parts_array[i].replace(/(^\s+|\s+$)/g, '')
                    // Remove blanks
                    if (parts_array[i] == '') {
                        parts_array.splice(i, 1)
                    }
                }
                return parts_array
            },
            setBulkPricing(min_margin, min_margin_vendor) {
                // Get current vendor pricing and set margin above current prices
                // to protect bulk margin. Use hidden fields from inventory table
                // and find vendor pricing from the raw data (searchDataRaw).
                var textron_price = null
                var textron_list_price = null
                var textron_stock = 0
                var defense_price = null
                var defense_list_price = null
                var defense_stock = 0
                var replacement_cost = null
                var replacement_list_price = null
                var replacement_vendor = null
                // var replacement_stock = null
                for (let vdata of this.searchDataRaw) {
                    // debugger
                    if (vdata.site == 'Textron') {
                        if ([vdata.part, vdata.substitute_for].includes(this.part_selected)) {
                            for (let vrow of vdata.data) {
                                if (vrow.PartNumber == this.q_part_quoted) {
                                    let price = 0.0
                                    if (Object.prototype.hasOwnProperty.call(vrow, 'your_price')) {
                                        price = Number(vrow.your_price.replace(/[^0-9-.]+/g, ''))
                                    }
                                    if (price == 0.0) {
                                        if (
                                            Object.prototype.hasOwnProperty.call(vrow, 'list_price')
                                        ) {
                                            let list_price = Number(
                                                vrow.list_price.replace(/[^0-9-.]+/g, '')
                                            )
                                            if (list_price == 0.0) {
                                                continue
                                            }
                                            textron_list_price = list_price
                                        }
                                        continue
                                    }
                                    if ((textron_price == null) | (price < textron_price)) {
                                        textron_price = price
                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                vrow,
                                                'stock_wichita'
                                            )
                                        ) {
                                            let textron_stock_wichita = Number(vrow.stock_wichita)
                                            if (!Number.isNaN(textron_stock_wichita))
                                                textron_stock = textron_stock_wichita
                                        }
                                        if (
                                            Object.prototype.hasOwnProperty.call(vrow, 'list_price')
                                        ) {
                                            let list_price = Number(
                                                vrow.list_price.replace(/[^0-9-.]+/g, '')
                                            )
                                            if (list_price == 0.0) {
                                                continue
                                            }
                                            textron_list_price = list_price
                                        }
                                    } else {
                                        continue
                                    }
                                }
                            }
                        }
                    }
                    if (vdata.site == 'Textron Defense') {
                        if ([vdata.part, vdata.substitute_for].includes(this.part_selected)) {
                            for (let vrow of vdata.data) {
                                if (vrow.part_number == this.q_part_quoted) {
                                    let price = 0.0
                                    if (Object.prototype.hasOwnProperty.call(vrow, 'your_price')) {
                                        price = Number(vrow.your_price.replace(/[^0-9-.]+/g, ''))
                                    }
                                    if (price == 0.0) {
                                        if (Object.prototype.hasOwnProperty.call(vrow, 'price')) {
                                            let list_price = Number(
                                                vrow.price.replace(/[^0-9-.]+/g, '')
                                            )
                                            if (list_price == 0.0) {
                                                continue
                                            }
                                            defense_list_price = list_price
                                        }
                                        continue
                                    }
                                    if ((defense_price == null) | (price < defense_price)) {
                                        defense_price = price
                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                vrow,
                                                'on_hand_qty'
                                            )
                                        ) {
                                            let stock = Number(vrow.on_hand_qty)
                                            if (!Number.isNaN(defense_stock)) defense_stock = stock
                                        }
                                        if (Object.prototype.hasOwnProperty.call(vrow, 'price')) {
                                            let list_price = Number(
                                                vrow.price.replace(/[^0-9-.]+/g, '')
                                            )
                                            if (list_price == 0.0) {
                                                continue
                                            }
                                            defense_list_price = list_price
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (min_margin_vendor) {
                    if (min_margin_vendor.toUpperCase() == 'TEXTRON') {
                        replacement_vendor = 'Textron'
                        replacement_cost = textron_price
                        // replacement_stock = textron_stock
                        replacement_list_price = textron_list_price
                    } else if (
                        (min_margin_vendor.toUpperCase() == 'TEXTRON DEFENSE') |
                        (min_margin_vendor.toUpperCase() == 'DEFENSE')
                    ) {
                        replacement_vendor = 'Textron Defense'
                        replacement_cost = defense_price
                        // replacement_stock = defense_stock
                        replacement_list_price = defense_list_price
                    }
                } else {
                    // Compare stock values before choosing
                    if (
                        ((textron_stock > 0) & (defense_stock > 0)) |
                        ((textron_stock == 0) & (defense_stock == 0))
                    ) {
                        // Pick the lowest price
                        if ((textron_price == null) & (defense_price == null)) {
                            if ((textron_list_price != null) | (defense_list_price != null)) {
                                if (
                                    (textron_list_price < defense_list_price) |
                                    (defense_list_price == null)
                                ) {
                                    replacement_list_price = textron_list_price
                                } else if (
                                    (defense_list_price < textron_list_price) |
                                    (textron_list_price == null)
                                ) {
                                    replacement_list_price = defense_list_price
                                }
                            }
                        } else if ((textron_price < defense_price) | (defense_price == null)) {
                            replacement_vendor = 'Textron'
                            replacement_cost = textron_price
                            // replacement_stock = textron_stock
                            replacement_list_price = textron_list_price
                        } else if ((defense_price < textron_price) | (textron_price == null)) {
                            replacement_vendor = 'Textron Defense'
                            replacement_cost = defense_price
                            // replacement_stock = defense_stock
                            replacement_list_price = defense_list_price
                        }
                    } else if (textron_stock > 0) {
                        replacement_vendor = 'Textron'
                        replacement_cost = textron_price
                        // replacement_stock = textron_stock
                        replacement_list_price = textron_list_price
                    } else if (defense_stock > 0) {
                        replacement_vendor = 'Textron Defense'
                        replacement_cost = defense_price
                        // replacement_stock = defense_stock
                        replacement_list_price = defense_list_price
                    }
                }
                // let part_price = Number.parseFloat(replacement_cost / (1 - (min_margin))).toFixed(2)
                let margin_percent = min_margin * 100
                // // eslint-disable-next-line no-unused-vars
                // let message = ''
                // if(min_margin_vendor!=null){
                //   message = `Required Vendor:   ${replacement_vendor}\n`
                // }else{
                //   message = `Replacement Vendor:   ${replacement_vendor}\n`
                // }
                // message += `Replacement Cost:   ${numeral(replacement_cost).format('$0,0,0,0,0.00')}\nMinimum Margin:   ${margin_percent}%\n\nA MINIMUM quote of ${numeral(part_price).format('$0,0,0,0,0.00')} was calculated based on the above data.\n\nPlease adjust the margin/quote if appropriate...`
                // if(replacement_stock == 0 | replacement_stock == null){
                //   message += `\n\n**IMPORTANT**\nYou may be able to increase margin since all vendors are out of stock.`
                // }
                // if(replacement_cost>0){
                //   // alert(message)
                // }
                return [
                    replacement_cost,
                    replacement_vendor,
                    margin_percent,
                    replacement_list_price,
                ]
            },
        },
    }
</script>

<style scoped>
    /* vue-good_table styles */
    .title_div {
        margin-top: 1.5em;
    }
    .site {
        font-size: 2em;
    }
    :deep(table.vgt-table td) {
        padding: 0.2em;
    }
    :deep(.row_style_class) {
        max-height: 200px;
    }
    :deep(.preformatted) {
        font-family: monospace;
        white-space: pre-wrap;
    }
    /* modal styles */
    .modal {
        z-index: 99999;
    }
</style>

<style>
    #quote_form .field.column {
        margin-bottom: 0rem;
        padding: 0.5rem;
    }
    #quote_form.field:not(:last-child) {
        margin-bottom: 0rem;
    }
    /* fuzzy match styles */
    .levenshtein_delete {
        display: inline-block;
        width: 0.33em;
        height: 0.7em;
        background-color: red;
        border-radius: 5px;
    }
    .levenshtein_insert {
        background-color: greenyellow;
        border-radius: 5px;
    }
    .levenshtein_sub {
        background-color: yellow;
        border-radius: 5px;
    }
</style>
